import { useEffect, useState, Fragment, forwardRef } from 'react';
import {
  Button,
  Box,
  DialogTitle,
  Dialog,
  Typography,
  DialogContent,
  TextField,
  FormControl,
  DialogContentText,
  DialogActions,
  OutlinedInput,
  Input,
  FormHelperText,
  InputLabel,
  FilledInput,
  List,
  ListItem,
  makeStyles,
  ListItemText,
  ListItemIcon,
  Tab,
  Tabs,
  Autocomplete,
  LinearProgress,
  styled,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormGroup,
  Select,
  MenuItem,
  Popover,
  Menu,
  NativeSelect,
  Slider,
  Card,
  CardContent,
  CardActions,
  Breadcrumbs,
  Link,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import React from 'react';
import { FormContainer, TextFieldElement, AutocompleteElement, SelectElement, SliderElement } from 'react-hook-form-mui';
import {
  DataGridPro, GridToolbarQuickFilter, gridNumberComparator, GridToolbar, GridActionsCellItem, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton,
  GridToolbarExport, GridToolbarQuickFilterProps, GridToolbarColumnsButton
} from '@mui/x-data-grid-pro';
import { selectCurrentUser } from '../../../redux/reducers/authSlice';

import IconButton from '@mui/material/IconButton';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import LoopIcon from '@mui/icons-material/Loop';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ClearIcon from '@mui/icons-material/Clear';

import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import Grid from '@mui/material/Grid';
import { removeEmpty } from '../../../lib/utils/index.js';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { CSVLink } from 'react-csv';
import theme from '../../../theme';
import { getImporteNuevoMes, getEstadosHistoricosCDC } from '../../../edilia/index';
import { v4 as uuid } from 'uuid';
import { getCobranzasData, addCamposCobranza, addRendicionCobranza, addCvusCobranza, addIngresosDebito, addAdhesionDebito, deleteAdhesionDebito, addClientesDebito, deleteClientesDebito } from "./cobranzasSlice.js";
import _ from 'lodash';


export default function CobranzasCat() {
  const dispatch = useDispatch();
  const fetching = useSelector(state => state.cobranzas.fetching);
  const { indices, contratos, personas, clasesContratos, titularidades, pagos, campos, cvus, registros, detallesRendicion, instrumentosRendicion, cdcTitularidades,
    adhesionesClientesMap, clientesDebito, adhesionesDebito, ingresosDebito, detallesIngreso, campanas, tiposCampana, cdcContratos, rendiciones, funcHistoria } = useSelector(state => state.cobranzas.data);
  useEffect(() => { dispatch(getCobranzasData()) }, []);

  //---------Funciones
  function getTipoOperacion(tipoOperacion) {
    if (tipoOperacion === 'A') {
      return 'Actualizacion';
    } else {
      return 'Baja';
    }
  }
  function getLabel(id) {
    let option = (personas || [])?.find((p) => p.personaId === id);
    if (option?.personaFisica) {
      if (!option?.nombre && !option?.apellido && !option?.numeroDocumento) {
        return option?.email;
      }
      return option.nombre + ' ' + option.apellido + ' - ' + option.numeroDocumento;
    } else {
      if (!option?.denominacionSocial && !option?.cuit) return option?.email;
      return option?.denominacionSocial + ' - ' + option?.cuit;
    }
  }
  const getDropdownOptions = (contratoId) => {
    let personasAsArray = (personas || []);
    if (typeof contratoId === 'number') {
      let titulares = (titularidades || []).filter((t) => t.contratoId === contratoId);
      let personasT = [];
      for (let i = 0; i < titulares.length; i++) {
        personasT.push(personasAsArray.find((p) => p.personaId === titulares[i].personaId));
      }
      personasT = personasT.map((p) => {
        return <MenuItem value={p.personaId}>{getLabel(p.personaId)}</MenuItem>;
      });
      return personasT;
    }
  };
  function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }
  function getFecha(date) {
    date = new Date(parseInt(date)).toLocaleString().split(',');
    date = date[0].split('/');

    let m = date[1] < 10 ? padTo2Digits(date[1]) : date[1];
    let d = date[0] < 10 ? padTo2Digits(date[0]) : date[0];
    let y = date[2];

    var fullDate = y + m + d;
    return fullDate;
  }
  function getHora(date) {
    date = new Date(parseInt(date)).toLocaleString().split(',');
    let time = date[1];
    time = time.split(':');
    let h = time[0] < 10 ? padTo2Digits(time[0]) : time[0];
    let m = time[1] < 10 ? padTo2Digits(time[1]) : time[1];
    let s = time[2] < 10 ? padTo2Digits(time[2]) : time[2];
    return h + m + s;
  }
  function getFormatoFecha(fecha) {
    fecha = fecha.toString();
    let y = fecha.substring(0, 4);
    let m = fecha.substring(4, 6);
    let d = fecha.substring(6, 8);
    return d + '/' + m + '/' + y;
  }
  function getCVU(contratoId) {
    let masGrande = 0;
    let cvu = (cvus).filter((c) => parseInt(c.contratoId) === parseInt(contratoId));
    cvu.forEach((c) => (parseInt(c.fechaAlta) > masGrande ? (masGrande = parseInt(c.fechaAlta)) : masGrande));
    cvu = cvu?.find((c) => c.fechaAlta === masGrande.toString());
    if (masGrande !== 0) {
      return cvu.cvu; // + ' - Fecha de Alta: ' + getFormatoFecha(cvu.fechaAlta)
    } else {
      return 'No se ha cargado CVU';
    }
  }
  function getCbu(id) {
    let persona = (personas || []).find((p) => p.personaId === id);
    return persona?.cbu === null ? '' : persona?.cbu;
  }
  function getContratoLabel(id) {
    id = parseInt(id);
    let c = (contratos || []).find((c) => c.contratoId === id);
    let tipo = clasesContratos?.find((cc) => c.claseContratoId === cc.claseContratoId);
    return 'ID ' + id + ' - Tipo ' + tipo?.descripcion;
  }
  function getClaseContrato(id) {
    id = parseInt(id);
    let c = (contratos || []).find((c) => c.contratoId === id);
    let tipo = clasesContratos?.find((cc) => c?.claseContratoId === cc.claseContratoId);
    return tipo?.descripcion;
  }
  function getTitularidad(contratoId) {
    let titular = (titularidades || []).find((t) => t.contratoId === contratoId && t.titularPrincipal);
    return titular?.personaId;
  }
  function getCuitCliente(id) {
    let persona = (personas || []).find((p) => p.personaId === id);
    if (persona?.cuit !== null) {
      return parseInt(persona?.cuit);
    } else {
      return 'ert';
    }
  }
  function getNombreAdherente(id) {
    let option = (personas || []).find((p) => p.personaId === id);
    if (option?.personaFisica) {
      let nombreCompleto = option.nombre + ' ' + option.apellido;
      if (!option?.nombre && !option?.apellido && !option?.numeroDocumento) {
        return option?.email;
      }
      if (nombreCompleto.length > 30) {
        let nombre = option.nombre.split(' ');
        nombreCompleto = nombre[0] + ' ' + option.apellido;
      }
      return handleString(nombreCompleto);
    }
    if (option?.personaJuridica) {
      let nombreEmpresa = option?.denominacionSocial;
      if (nombreEmpresa.length > 30) {
        nombreEmpresa = nombreEmpresa.slice(0, 30);
      }
      return handleString(nombreEmpresa);
    }
  }
  function handleString(str) {
    str = str.replace('á', 'a');
    str = str.replace('Á', 'A');
    str = str.replace('é', 'e');
    str = str.replace('É', 'E');
    str = str.replace('í', 'i');
    str = str.replace('Í', 'I');
    str = str.replace('ó', 'o');
    str = str.replace('Ó', 'O');
    str = str.replace('ú', 'u');
    str = str.replace('Ú', 'U');
    str = str.replace('Ü', 'U');
    str = str.replace('ü', 'u');
    str = str.replace('Ñ', 'N');
    str = str.replace('ñ', 'n');
    str = str.replace("'", '');
    str = str.replace('`', '');
    str = str.replace('´', '');
    //str = str.toUpperCase()
    return str;
  }
  const fechaSortComparator = (v1, v2, param1, param2) => {
    function getFechaNumero(date) {
      date = date.split('/');
      let d = date[0] < 10 ? padTo2Digits(date[0]) : date[0];
      let m = date[1] < 10 ? padTo2Digits(date[1]) : date[1];
      let y = date[2];
      var fullDate = y + m + d;
      return parseInt(fullDate);
    }
    let fecha1 = getFechaNumero(param1.value);
    let fecha2 = getFechaNumero(param2.value);
    const ComparatorResult = gridNumberComparator(fecha1, fecha2);
    if (ComparatorResult !== 0) {
      return ComparatorResult;
    }
    return gridNumberComparator(v1.name, v2.name, param1, param2);
  };
  const importeSortComparator = (v1, v2, param1, param2) => {
    function getImporteNumero(importe) {
      importe = importe.replace('$', '').replace(',', '').replace('.', '');
      return parseInt(importe);
    }
    let number1 = getImporteNumero(param1.value);
    let number2 = getImporteNumero(param2.value);
    const ComparatorResult = gridNumberComparator(number1, number2);
    if (ComparatorResult !== 0) {
      return ComparatorResult;
    }
    return gridNumberComparator(v1.name, v2.name, param1, param2);
  };
  const moneyFormat = (v) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format(parseFloat(v).toFixed(2)).replace('ARS', '');
  //Rutas para cambiar en el menú desplegable del dashboard
  const [value, setValue] = useState(0);
  let location = useLocation();
  const [type, setType] = useState();
  useEffect(() => setType(location.pathname.toLowerCase().split('cobranzas/')[1].split('/')[0]), [location]);

  const Cobranzas = (props) => {
    const currentUser = useSelector(selectCurrentUser);

    const GridAction = (props) => {
      const [anchorEl, setAnchorEl] = useState(null);

      const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
      };

      const handlePopoverClose = () => {
        setAnchorEl(null);
      };
      const { label, key, Icon, color } = props;
      const open = Boolean(anchorEl);
      return (
        <Fragment key={key + label}>
          <Icon
            aria-owns={open ? label : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
            color={color}>
            {' '}
          </Icon>
          <Popover
            id={label}
            sx={{
              pointerEvents: 'none',
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus>
            <Typography sx={{ p: 1 }}>{label}</Typography>
          </Popover>
        </Fragment>
      );
    };
    // Debito Automático ---------
    const DebitoDirectoTable = (props) => {
      //-----------------------ADHESIONES
      function AdhesionesDebito() {
        const [selectedAdhesiones, setSelectedAdhesiones] = useState([]);
        const [detalleModal, setDetalleModal] = useState(false);
        const [showDetalleModal, setShowDetalleModal] = useState(false);
        const openDetalleModal = () => setShowDetalleModal(true);
        const closeDetalleModal = () => setShowDetalleModal(false);
        const [feriados, setFeriados] = useState([]);
        const [showAdhesionForm, setShowAdhesionForm] = useState(false);

        const [showBorrarAdhesion, setShowBorrarAdhesion] = useState(false);
        const closeBorrarAdhesion = () => setShowBorrarAdhesion(false);
        const closeAdhesionForm = () => {
          setShowAdhesionForm(false);
          setSelectedAdhesiones([]);
        };
        //GET feriados nacionales
        useEffect(() => {
          const fetchFeriados = async () => {
            try {
              const year = new Date().getFullYear();
              const response = await fetch(`http://nolaborables.com.ar/api/v2/feriados/${year}`);
              if (response.ok) {
                const data = await response.json();
                setFeriados(data);
              } else {
                console.error('Error fetching data');
              }
            } catch (error) {
              console.error('Error:', error);
            }
          };
          const feriados2024 = [{ "motivo": "Año Nuevo", "tipo": "inamovible", "info": "https://es.wikipedia.org/wiki/A%C3%B1o_Nuevo", "dia": 1, "mes": 1, "id": "año-nuevo" }, { "motivo": "Carnaval", "tipo": "inamovible", "info": "https://es.wikipedia.org/wiki/Carnaval", "dia": 12, "mes": 2, "id": "carnaval" }, { "motivo": "Carnaval", "tipo": "inamovible", "info": "https://es.wikipedia.org/wiki/Carnaval", "dia": 13, "mes": 2, "id": "carnaval" }, { "motivo": "Día Nacional de la Memoria por la Verdad y la Justicia", "tipo": "inamovible", "info": "https://es.wikipedia.org/wiki/D%C3%ADa_Nacional_de_la_Memoria_por_la_Verdad_y_la_Justicia", "dia": 24, "mes": 3, "id": "memoria-verdad-justicia" }, { "motivo": "Viernes Santo Festividad Cristiana", "tipo": "inamovible", "info": "https://es.wikipedia.org/wiki/Viernes_Santo", "dia": 29, "mes": 3, "id": "viernes-santo" }, { "motivo": "Feriado Puente Turístico", "tipo": "puente", "info": "https://es.wikipedia.org/wiki/Puente_festivo", "dia": 1, "mes": 4, "id": "puente-turistico" }, { "motivo": "Día del Veterano y de los Caídos en la Guerra de Malvinas", "tipo": "inamovible", "info": "https://es.wikipedia.org/wiki/D%C3%ADa_del_Veterano_y_de_los_Ca%C3%ADdos_en_la_Guerra_de_Malvinas", "dia": 2, "mes": 4, "id": "veteranos-malvinas" }, { "motivo": "Día del Trabajador", "tipo": "inamovible", "info": "https://es.wikipedia.org/wiki/D%C3%ADa_Internacional_de_los_Trabajadores", "dia": 1, "mes": 5, "id": "trabajador" }, { "motivo": "Día de la Revolución de Mayo", "tipo": "inamovible", "info": "https://es.wikipedia.org/wiki/Revoluci%C3%B3n_de_Mayo", "dia": 25, "mes": 5, "id": "revolucion-mayo" }, { "motivo": "Paso a la Inmortalidad del Gral. Don Martín Güemes", "tipo": "trasladable", "original": "17-06", "info": "https://es.wikipedia.org/wiki/Mart%C3%ADn_Miguel_de_G%C3%BCemes", "dia": 17, "mes": 6, "id": "martin-guemes" }, { "motivo": "Paso a la Inmortalidad del General Manuel Belgrano", "tipo": "inamovible", "info": "https://es.wikipedia.org/wiki/D%C3%ADa_de_la_Bandera_(Argentina)", "dia": 20, "mes": 6, "id": "belgrano" }, { "motivo": "Feriado Puente Turístico", "tipo": "puente", "info": "https://es.wikipedia.org/wiki/Puente_festivo", "dia": 21, "mes": 6, "id": "puente-turistico" }, { "motivo": "Día de la Independencia", "tipo": "inamovible", "info": "https://es.wikipedia.org/wiki/Declaraci%C3%B3n_de_independencia_de_la_Argentina", "dia": 9, "mes": 7, "id": "independencia" }, { "motivo": "Paso a la Inmortalidad del General José de San Martín", "tipo": "trasladable", "original": "17-08", "info": "https://es.wikipedia.org/wiki/Jos%C3%A9_de_San_Mart%C3%ADn", "dia": 19, "mes": 8, "id": "san-martin" }, { "motivo": "Feriado Puente Turístico", "tipo": "puente", "info": "https://es.wikipedia.org/wiki/Puente_festivo", "dia": 11, "mes": 10, "id": "puente-turistico" }, { "motivo": "Día del Respeto a la Diversidad Cultural", "tipo": "trasladable", "original": "12-10", "info": "https://es.wikipedia.org/wiki/D%C3%ADa_del_Respeto_a_la_Diversidad_Cultural_(Argentina)", "dia": 12, "mes": 10, "id": "diversidad" }, { "motivo": "Día de la Soberanía Nacional", "tipo": "trasladable", "original": "20-11", "info": "https://es.wikipedia.org/wiki/D%C3%ADa_de_la_Soberan%C3%ADa_Nacional", "dia": 18, "mes": 11, "id": "soberania-nacional" }, { "motivo": "Inmaculada Concepción de María", "tipo": "inamovible", "info": "https://es.wikipedia.org/wiki/Inmaculada_Concepci%C3%B3n", "dia": 8, "mes": 12, "id": "inmaculada-maria" }, { "motivo": "Navidad", "tipo": "inamovible", "info": "https://es.wikipedia.org/wiki/Navidad", "dia": 25, "mes": 12, "id": "navidad" }]
          setFeriados(feriados2024);
          //fetchFeriados();
        }, []);
        //Funciónes de Boton 'Detalles'
        function handleDetalle(id) {
          setDetalleModal(id);
          openDetalleModal();
        };
        const DetalleModal = (props) => {
          let clientesMap = (
            adhesionesClientesMap || []
          ).filter((c) => c.adhesionDebitoId === detalleModal);
          let clientesAdhesion = (clientesDebito || [])
            .filter((c) =>
              clientesMap
                ?.map((c) => c.clienteDebitoId)
                .includes(c.clienteDebitoId)
            )
            .map((r) => ({
              ...r,
              tipoContrato: getClaseContrato(r.contratoId),
              cbu: clientesMap.find(
                (c) => c.clienteDebitoId === r.clienteDebitoId
              )?.cbu,
              importeDebitoAdhesion: clientesMap.find(
                (c) => c.clienteDebitoId === r.clienteDebitoId
              )?.importeDebitoAdhesion,
            }));

          const [valueTabs, setValueTabs] = useState(0);
          function handleDownload(id) {
            let fechas = (adhesionesDebito).find(
              (a) => a.adhesionDebitoId === detalleModal
            );
            let clientesMap = (
              adhesionesClientesMap || []
            ).filter((c) => c.adhesionDebitoId === detalleModal);
            let clientesAdhesion = (clientesDebito || [])
              .filter((c) =>
                clientesMap
                  ?.map((c) => c.clienteDebitoId)
                  .includes(c.clienteDebitoId)
              ).map((r) => ({
                ...r,
                tipoContrato: getClaseContrato(r.contratoId),
                cbu: clientesMap.find(
                  (c) => c.clienteDebitoId === r.clienteDebitoId
                )?.cbu,
                importeDebitoAdhesion: clientesMap.find(
                  (c) => c.clienteDebitoId === r.clienteDebitoId
                )?.importeDebitoAdhesion,
              }));


            let selectedAdhesion = (
              adhesionesDebito
            ).find((a) => a.adhesionDebitoId === detalleModal);
            let clientes = (
              adhesionesClientesMap
            ).filter((c) => c.adhesionDebitoId === detalleModal);
            const datos = clientesAdhesion.map((c) => [
              c.cbu,
              (c.importeDebitoAdhesion / 100),
              c.partida,
              c.referenciaEmpresa + '-' + uuid().substring(29, 35),
              new Date(parseInt(fechas.fechaPresentacion))
                .toLocaleString()
                .split(",")[0],
              new Date(parseInt(fechas.fechaVencimiento))
                .toLocaleString()
                .split(",")[0],
              c.nombreAdherente || "", // Si nombreAdherente está vacío, se asigna una cadena vacía
            ]);
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.aoa_to_sheet([
              [
                "CBU",
                "Importe",
                "Partida",
                "Referencia",
                "Fecha Presentación",
                "Fecha Vencimiento",
                "Nombre Adherente (opcional)",
              ],
              ...datos,
            ]);
            // Definir el estilo para los encabezados de columna
            const headerStyle = {
              fill: {
                fgColor: { rgb: "FF0000" }, // Red background color
              },
              font: {
                color: { rgb: "FFFFFF" }, // White text color
              },
              alignment: {
                horizontal: "center", // Centrar el texto horizontalmente
                vertical: "center", // Centrar el texto verticalmente
              },
            };

            // Obtener las celdas de los encabezados de columna
            const headerCells = Object.keys(worksheet)
              .filter((key) => key.startsWith("A1:"))
              .map((key) => worksheet[key]);
            // Aplicar el estilo a los encabezados de columna
            headerCells.forEach((cell) => {
              cell.s = headerStyle;
            });
            // Configurar el ancho de las columnas
            const columnWidths = [
              { wch: 25 }, // Ancho de la columna CBU
              { wch: 15 }, // Ancho de la columna Importe
              { wch: 15 }, // Ancho de la columna Partida
              { wch: 15 }, // Ancho de la columna Referencia
              { wch: 15 }, // Ancho de la columna Fecha Presentación
              { wch: 15 }, // Ancho de la columna Fecha Vencimiento
              { wch: 25 }, // Ancho de la columna Nombre Adherente
            ];
            worksheet["!cols"] = columnWidths;

            XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");

            // Generar el archivo Excel
            const excelBuffer = XLSX.write(workbook, {
              type: "array",
              bookType: "xlsx",
            });

            const blob = new Blob([excelBuffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `Adhesion Debito N° ${selectedAdhesion.adhesionDebitoId} - Presentación: ${selectedAdhesion.fechaPresentacion} - Vencimiento: ${selectedAdhesion.fechaVencimiento}.xlsx`;
            link.click();
            URL.revokeObjectURL(url);
          }
          const VistaArchivoModal = (props) => {
            let fechas = (adhesionesDebito).find(
              (a) => a.adhesionDebitoId === detalleModal
            );
            const columnsR = [
              {
                field: "cbu",
                headerName: "CBU",
                width: 200,
              },
              {
                field: "importeDebitoAdhesion",
                headerName: "Importe",
                width: 100,
                valueGetter: (v) => ('$' + moneyFormat(parseFloat(v.row.importeDebitoAdhesion) / 100)),
                sortComparator: importeSortComparator,
              },
              { field: "partida", headerName: "Partida", width: 170 },
              {
                field: "referenciaEmpresa",
                headerName: "Referencia",
                width: 100,
              },
              {
                field: "fechaPresentacion",
                headerName: "Fecha Presentacion",
                width: 150,
                valueGetter: (v) => getFormatoFecha(getFecha(fechas.fechaPresentacion)),
              },
              {
                field: "fechaVencimiento",
                headerName: "Fecha Vencimiento",
                width: 150,
                valueGetter: (v) =>
                  getFormatoFecha(getFecha(fechas.fechaVencimiento)),
              },
              {
                field: "nombreAdherente",
                headerName: "Nombre Adherente (opcional)",
                width: 200,
              },
            ];
            return (
              <Fragment>
                <Box fullWidth
                >
                  <DataGridPro
                    pagination
                    fullWidth
                    sx={{ height: '50vh' }}
                    getRowId={(r) => r.clienteDebitoId}
                    initialState={{
                      sorting: {
                        sortModel: [{ field: "ID", sort: "asc" }],
                      },
                    }}
                    rows={clientesAdhesion || []}
                    columns={columnsR}
                    pageSize={100}
                    rowsPerPageOptions={[clientesAdhesion.length]}
                    experimentalFeatures={{ newEditingApi: true }}
                    components={{}}
                    GridLinesVisibility="All"
                    componentsProps={{}}
                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                      },
                    }}
                  />
                </Box>
              </Fragment>
            );
          };
          const DetalleClientes = (props) => {
            const columnsR = [
              {
                field: "contratoId",
                headerName: "Contrato ID",
                width: 100,
              },
              {
                field: "tipoContrato",
                headerName: "Tipo de contrato",
                width: 250,
              },
              { field: "personaId", headerName: "Persona ID", width: 170 },
              {
                field: "nombreAdherente",
                headerName: "Nombre cliente",
                width: 170,
              },
              {
                field: "cbu",
                headerName: "CBU",
                width: 150,
              },
              {
                field: "importeDebitoAdhesion",
                headerName: "Importe",
                width: 150,
                valueGetter: (v) => ('$' + moneyFormat(parseFloat(v.row.importeDebitoAdhesion) / 100)),
                sortComparator: importeSortComparator,
              },
            ];
            return (
              <Fragment>
                <Box fullWidth
                >
                  <DataGridPro
                    fullWidth
                    pagination
                    sx={{ height: '50vh' }}
                    getRowId={(r) => r.clienteDebitoId}
                    initialState={{
                      sorting: {
                        sortModel: [{ field: "ID", sort: "asc" }],
                      },
                    }}
                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                      },
                    }}
                    rows={clientesAdhesion || []}
                    columns={columnsR}
                    pageSize={100}
                    rowsPerPageOptions={[6]}
                    //disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    components={{ Toolbar: GridToolbar }}
                    componentsProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                  />
                </Box>
              </Fragment>
            );
          };
          function TabPanel(props) {
            const { children, value, index, ...other } = props;
            return (
              <div
                role="tabpanel"
                hidden={valueTabs !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
              >
                {valueTabs === index && (
                  <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                  </Box>
                )}
              </div>
            );
          }
          const ModalTabs = () => {
            function a11yProps(index) {
              return {
                id: `simple-tab-${index}`,
                "aria-controls": `simple-tabpanel-${index}`,
              };
            }
            const handleChange = (event, newValue) => {
              setValueTabs(newValue);
            };

            return (
              <>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    value={valueTabs}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                  >
                    <Tab label="Clientes publicados" {...a11yProps(0)} />
                    <Tab label="Vista del archivo" {...a11yProps(1)} />
                  </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                  <DetalleClientes />
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <VistaArchivoModal />
                </TabPanel>
              </>
            );
          };
          return (
            <Fragment>
              <Dialog
                onClose={closeDetalleModal}
                open={showDetalleModal}
                maxWidth="xl"
              >
                <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>
                  Detalles de la adhesión N° {detalleModal}:
                </DialogTitle>
                <DialogContent dividers>
                  <Box sx={{ height: 500, width: 1200 }}>
                    <ModalTabs />
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Button
                  disabled={fetching > 0}
                    component="button"
                    variant="contained"
                    size="small"
                    onClick={() => handleDownload(detalleModal)}
                  >
                    Descargar archivo <FileDownloadIcon></FileDownloadIcon>
                  </Button>
                  <Button disabled={fetching > 0} onClick={() => setShowDetalleModal(false)}>
                    Volver
                  </Button>
                </DialogActions>
              </Dialog>
            </Fragment>
          );
        };
        const BorrarAdhesionForm = (props) => {
          function handleBorrar() {
            dispatch(deleteAdhesionDebito([selectedAdhesiones.adhesionDebitoId]))
              .unwrap()
              .then(console.log)
              .catch(console.log);
            setSelectedAdhesiones([]);
          }
          return (
            <Fragment>
              <Dialog
                onClose={closeBorrarAdhesion}
                open={showBorrarAdhesion}
                maxWidth="md"
              >
                <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Borrar adhesion:
                </DialogTitle>
                <DialogContent dividers>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography>
                        ¿Seguro quiere borrar la siguiente adhesion del débito directo?
                      </Typography>
                    </Grid>
                    <List sx={{ paddingLeft: "10px", paddingRight: "10px" }}>
                      <ListItem>
                        <ListItemIcon>
                          <AccountBalanceIcon></AccountBalanceIcon>
                        </ListItemIcon>
                        <ListItemText>
                          Adhesion ID: {selectedAdhesiones.adhesionDebitoId} - Fecha de
                          presentación:{" "}
                          {getFormatoFecha(getFecha(selectedAdhesiones.fechaPresentacion))}{" "}
                          - Fecha de Vencimiento:{" "}
                          {getFormatoFecha(getFecha(selectedAdhesiones.fechaVencimiento))}-
                          Importe total: {selectedAdhesiones.importeTotalAdhesion}{" "}
                        </ListItemText>
                      </ListItem>
                    </List>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button
                  disabled={fetching > 0}
                    sx={{ marginRight: '5px', marginButtom: '15px', fontWeight: "bold" }}
                    variant="outlined"
                    onClick={closeBorrarAdhesion}
                  >
                    {"Cancelar"}
                  </Button>
                  <Button
                  disabled={fetching > 0}
                    sx={{ marginRight: '5px', marginButtom: '15px', fontWeight: "bold" }}
                    variant="contained"
                    onClick={handleBorrar}
                  >
                    {"Aceptar"}
                  </Button>
                </DialogActions>
              </Dialog>
            </Fragment>
          );
        };
        //-------------------- Formulario
        const AdhesionForm = (props) => {

          const context = {
            clasesContratos,
            CDCContratos: cdcContratos,
            eventosAdjudicacion: [],
            adjudicaciones: [],
            ofertasDinerarias: [],
            titularidades: (titularidades || []),
            CDCTitularidades: (cdcTitularidades || []),
            canalesAdjudicacion: [],
            edificios: [],
            departamentos: [],
            entregasUnidades: [], // TODO: await sql.get(ENTREGAS_UNIDADES_TABLE),
            intencionesPago: [],
            campanas: (campanas || []),
            tiposCampanas: tiposCampana,
            pagos: (pagos || []),
            indices: (indices || []),
          };
          const [checked, setChecked] = useState(false);
          const [checkHeader, setCheckHeader] = useState(false);
          const [errores, setErrores] = useState([]);
          const [fechas, setFechas] = useState({
            fechaPresentacion: dayjs(),
            fechaVencimiento:
              dayjs().add(4, 'day').day() === 0
                ? dayjs().add(5, 'day')
                : dayjs().add(4, 'day').day() === 6
                  ? dayjs().add(6, 'day')
                  : dayjs().add(4, 'day'),
          });

          const [clientes, setClientes] = useState([]);
          let rowsClientes = (clientesDebito || [])
            .map((c) => ({
              ...c,
              cbu: getCbu(c.personaId),
              importeDebitoAdhesion: 0,
            }))
            .filter((c) => c.eliminado === false);
          const [numberImputs, setNumberImputs] = useState(
            rowsClientes.map((c) => ({
              cbu: getCbu(c.personaId),
              importeDebitoAdhesion: 0,
              clienteDebitoId: c.clienteDebitoId,
              personaId: c.personaId,
              contratoId: c.contratoId,
            })),
          );

          const [selectedRows, setSelectedRows] = useState(
            rowsClientes.map((c) => {
              const adhesion = selectedAdhesiones.length === 1 ? selectedAdhesiones[0] : null;
              const selected =
                adhesion &&
                (adhesionesClientesMap || [])
                  ?.filter((a) => parseInt(a.adhesionDebitoId) === parseInt(adhesion))
                  ?.find((cd) => cd.clienteDebitoId === c.clienteDebitoId) != null;
              return { selected, clienteDebitoId: c.clienteDebitoId };
            }),
          );
          const [campos, setCampos] = useState([...rowsClientes]);
          let ultimaAdhesionId = rows[0]?.adhesionDebitoId || [];
          let clientesIds = (adhesionesClientesMap || [])
            .filter((a) => parseInt(a.adhesionDebitoId) === parseInt(ultimaAdhesionId))
            .map((c) => c.clienteDebitoId);

          // ------------------Funciones para el formulario
          const CBUCell = (v) => {
            const [cbu, setCbu] = useState(numberImputs.find((c) => c.clienteDebitoId === v.row.clienteDebitoId).cbu);
            const handleChange = (e) => {
              setNumberImputs([
                ...numberImputs.map((c) => (c.personaId === v.row.personaId ? { ...c, cbu: e.target.value } : c)),
              ]);
              setCbu(e.target.value);
            };
            return (
              <FormControl fullWidth key={`form-control-${v.row.clienteDebitoId}`}>
                <Input value={cbu} onChange={handleChange} id="outlined-adornment-weight" type="number" />
              </FormControl>
            );
          };
          useEffect(() => {
            //console.log('rowsFechas', fechas)
            //console.log('rowsFechas', { funcHistoria, clasesContratos, indices, pagos, titularidades, campanas, contratos, cdcContratos, tiposCampana })
            let fechaVencimiento = new Date(fechas.fechaVencimiento.valueOf())
            let primerDiaDelMes = new Date(fechaVencimiento.getFullYear(), (fechaVencimiento.getMonth()), 1).setHours(6, 0, 0, 0);
            if (funcHistoria && clasesContratos && indices && pagos && titularidades && campanas && contratos && cdcContratos && tiposCampana && cdcTitularidades) {
              Promise.all(rowsClientes.map(r => new Promise(async (resolve, reject) => {
                const result = await eval(funcHistoria)(r.contratoId, context, -2, getEstadosHistoricosCDC(cdcContratos.filter(x => parseInt(r.contratoId) === parseInt(x.contratoId))), primerDiaDelMes).catch(reject);

                const importes = getImporteNuevoMes(_.last(result));
                resolve({ ...r, importeDebitoAdhesion: importes.importeTotal })
              })))
                .then(setNumberImputs).catch(console.error)
            };
          }, [funcHistoria, clasesContratos, indices, pagos, titularidades, campanas, contratos, cdcContratos, tiposCampana, fechas]);
          const ImporteCell = (v) => {
            const [importe, setImporte] = useState((numberImputs?.find(c => c.clienteDebitoId === v.row.clienteDebitoId)?.importeDebitoAdhesion))
            useEffect(() => {
              let number = numberImputs?.find(c => c.clienteDebitoId === v.row.clienteDebitoId)?.importeDebitoAdhesion
              if (number !== importe) setImporte(number)
            }, [numberImputs]);
            const handleChange = (value) => {
              setNumberImputs([
                ...numberImputs.map((c) =>
                  c.contratoId === v.row.contratoId ? { ...c, importeDebitoAdhesion: value } : c,
                ),
              ]);
              setImporte(value);
            };

            return (
              <FormControl fullWidth key={`form-control-importe${v.row.clienteDebitoId}`}>
                <Input
                  value={importe}
                  onChange={(e) => handleChange(e.target.value)}
                  id="outlined-adornment-weight"
                  type="number"
                />
              </FormControl>
            );
          };
          const CheckCell = (v) => {
            const [check, setCheck] = useState(selectedRows.find((c) => c.clienteDebitoId === v.row.clienteDebitoId));
            let change = !check;
            const handleChange = (e) => {
              setSelectedRows([
                ...selectedRows.map((c) =>
                  c.clienteDebitoId === v.row.clienteDebitoId ? { ...c, selected: !check.selected } : c,
                ),
              ]);
              setCheck({
                selected: !check.selected,
                clienteDebitoId: v.row.clienteDebitoId,
              });
            };
            return (
              <Checkbox
                key={`form-control-checkcell-${v.row.clienteId}`}
                checked={selectedRows.find((r) => r.clienteDebitoId === v.row.clienteDebitoId).selected}
                onChange={handleChange}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            );
          };
          const HeaderCell = () => {
            let changeHeader = !checkHeader;
            const handleChangeHeaderCell = (e) => {
              if (checked) {
                setSelectedRows([
                  ...selectedRows.map((c) =>
                    clientesIds.includes(c.clienteDebitoId) ? c : { ...c, selected: changeHeader },
                  ),
                ]);
              } else {
                setSelectedRows([
                  ...selectedRows.map((c) => ({
                    ...c,
                    selected: changeHeader,
                  })),
                ]);
              }
              setCheckHeader(changeHeader);
            };
            return (
              <Checkbox
                checked={checkHeader}
                onChange={handleChangeHeaderCell}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            );
          };
          const handleCheck = () => {
            let change = !checked;
            if (change === true && clientesIds?.length !== 0) {
              setSelectedRows(
                selectedRows.map((r) => (clientesIds.includes(r.clienteDebitoId) ? { ...r, selected: true } : r)),
              );
            } else {
              if (!checkHeader) {
                setSelectedRows(
                  selectedRows.map((r) => (clientesIds.includes(r.clienteDebitoId) ? { ...r, selected: false } : r)),
                );
              }
            }
            setChecked(!checked);
          };

          const shouldDisableDate = (date) => {
            let ultimoIndice = _.last((indices || []));
            const fechaUltimoIndice = new Date(parseInt(ultimoIndice?.fecha));
            // Create a date two months ahead of fechaUltimoIndice
            const twoMonthsAhead = new Date(fechaUltimoIndice);
            twoMonthsAhead.setMonth(twoMonthsAhead.getMonth() + 2);
            let fecha = new Date(parseInt(date.valueOf())).toLocaleString().split(',')[0].split('/');
            if (
              date.day() === 0 ||
              date.day() === 6 ||
              feriados?.find((f) => parseInt(f.mes) === parseInt(fecha[1]) && parseInt(f.dia) === parseInt(fecha[0])) ||
              date.valueOf() >= twoMonthsAhead.valueOf() ||
              (date.month() > twoMonthsAhead.getMonth())
            ) {
              return true;
            }
            return false;
          };

          //----------------Función que se llama al apretar el botón 'Aceptar' y raliza validaciones.
          function handleSubmit() {
            let idsFiltrar = selectedRows.filter((r) => r.selected === true).map((r) => r.clienteDebitoId);
            let camposFiltrados = [...campos].filter((c) => idsFiltrar.includes(c.clienteDebitoId));
            let importeTotalAdhesion = 0;
            //console.log(numberImputs)
            setErrores([]);
            for (let campo of camposFiltrados) {
              campo.importeDebitoAdhesion = numberImputs.find(
                (c) => c.clienteDebitoId === campo.clienteDebitoId,
              ).importeDebitoAdhesion;
              importeTotalAdhesion += parseFloat(campo.importeDebitoAdhesion);
              campo.cbu = numberImputs.find((c) => c.clienteDebitoId === campo.clienteDebitoId).cbu;
              let errs = [];
              let huboError = false; //FIX: setState es una funcion asincronica, no se puede usar como condicion la logintud del array errores
              if (campo.cbu === undefined || campo.cbu === '') {
                errs = [...errs, 'Contrato N° ' + campo.contratoId + ': Debe completar el campo "CBU"'];
                huboError = true;
              } else {
                if (campo.cbu.toString().length !== 22) {
                  errs = [
                    ...errs,
                    'Contrato N° ' +
                    campo.contratoId +
                    ': Debe ingresar un CBU de 22 digitos. El campo "CBU" tiene ' +
                    campo.cbu.toString().length +
                    ' digitos.',
                  ];
                  huboError = true;
                }
              }
              if (parseInt(campo.importeDebitoAdhesion) >= 3000000) {
                errs = [...errs, 'Contrato N° ' + campo.contratoId + ': El importe debe ser menor a $3.000.000,00'];
                huboError = true;
              }
              setErrores(errs);
              if (huboError) return;
            }
            if (parseFloat(importeTotalAdhesion) >= 11000000.0) {
              let huboError = true;
              let errs = ['El importe total a debitar mensual debe ser menor a $11.000.000,00'];
              setErrores(errs);
              if (huboError) return;
            }
            if (camposFiltrados.length > 500) {
              let huboError = true;
              let errs = [
                'La cantidad máxima de clientes a presentar mensualmente y por adhesión es de 300. Usted ha seleccionado ' +
                camposFiltrados.length.toString() +
                'clientes.',
              ];
              setErrores(errs);
              if (huboError) return;
            }
            if (fechas.fechaPresentacion === undefined) {
              let huboError = true;
              let errs = ['Debe ingresar una fecha de presentación.'];
              setErrores(errs);
              if (huboError) return;
            }
            if (fechas.fechaVencimiento === undefined) {
              let huboError = true;
              let errs = ['Debe ingresar una fecha de vencimiento.'];
              setErrores(errs);
              if (huboError) return;
            }
            setClientes([...camposFiltrados]);
            openModalConfirmacion();
          }
          //----------------Columnas del formulario
          const columns = [
            {
              field: 'check',
              width: 50,
              renderCell: CheckCell,
              renderHeader: HeaderCell,
              sortable: false,
            },
            {
              field: 'clienteDebitoId',
              headerName: 'Cliente Debito ID',
              width: 100,
            },
            {
              field: 'contrato',
              headerName: 'Contrato Id',
              width: 70,
              valueGetter: (v) => parseInt(v.row.contratoId),
            },
            {
              headerName: 'Tipo de Contrato',
              width: 250,
              valueGetter: (v) => (v.row.contratoId ? getClaseContrato(parseInt(v.row.contratoId)) : '-'),
            },
            {
              field: 'personaId',
              headerName: 'Cliente',
              width: 200,
              valueGetter: (v) => (v.row.personaId ? getLabel(parseInt(v.row.personaId)) : '-'),
            },
            {
              field: 'cbu',
              headerName: 'CBU',
              width: 250,
              renderCell: CBUCell,
            },
            {
              field: 'importeDebitoAdhesion',
              headerName: 'Importe ',
              width: 150,
              renderCell: ImporteCell,
              sortComparator: importeSortComparator,
            },
          ];
          //-------------------Modal confirmación
          const [modalConfirmacion, setModalConfirmacion] = useState(false);
          const openModalConfirmacion = () => setModalConfirmacion(true);
          const closeModalConfirmacion = () => setModalConfirmacion(false);
          const ModalConfirmacion = (props) => {
            let importeTotalAdhesion = 0;
            clientes.forEach((c) => (importeTotalAdhesion += parseFloat(c.importeDebitoAdhesion)));
            function handleCreate() {
              // Para transformar de milisegundos a fecha: (new Date(parseInt(fecha))).toLocaleString().split(',')[0]
              let fechasFormateadas = {
                fechaPresentacion: new Date(parseInt(fechas.fechaPresentacion.valueOf()))
                  .toLocaleString()
                  .split(',')[0],
                fechaVencimiento: new Date(parseInt(fechas.fechaVencimiento.valueOf())).toLocaleString().split(',')[0],
              };
              const datos = clientes.map((c) => [
                c.cbu,
                parseFloat(c.importeDebitoAdhesion),
                c.partida,
                c.referenciaEmpresa + '-' + uuid().substring(29, 34),
                fechasFormateadas.fechaPresentacion,
                fechasFormateadas.fechaVencimiento,
                c.nombreAdherente || '', // Si nombreAdherente está vacío, se asigna una cadena vacía
              ]);

              // Crear el libro de trabajo de Excel
              const workbook = XLSX.utils.book_new();
              const worksheet = XLSX.utils.aoa_to_sheet([
                [
                  'CBU',
                  'Importe',
                  'Partida',
                  'Referencia',
                  'Fecha Presentación',
                  'Fecha Vencimiento',
                  'Nombre Adherente (opcional)',
                ],
                ...datos,
              ]);
              // Definir el estilo para los encabezados de columna
              const headerStyle = {
                fill: {
                  fgColor: { rgb: 'FF0000' }, // Red background color
                },
                font: {
                  color: { rgb: 'FFFFFF' }, // White text color
                },
                alignment: {
                  horizontal: 'center', // Centrar el texto horizontalmente
                  vertical: 'center', // Centrar el texto verticalmente
                },
              };

              // Obtener las celdas de los encabezados de columna
              const headerCells = Object.keys(worksheet)
                .filter((key) => key.startsWith('A1:'))
                .map((key) => worksheet[key]);
              // Aplicar el estilo a los encabezados de columna
              headerCells.forEach((cell) => {
                cell.s = headerStyle;
              });
              // Configurar el ancho de las columnas
              const columnWidths = [
                { wch: 25 }, // Ancho de la columna CBU
                { wch: 15 }, // Ancho de la columna Importe
                { wch: 15 }, // Ancho de la columna Partida
                { wch: 15 }, // Ancho de la columna Referencia
                { wch: 15 }, // Ancho de la columna Fecha Presentación
                { wch: 15 }, // Ancho de la columna Fecha Vencimiento
                { wch: 25 }, // Ancho de la columna Nombre Adherente
              ];
              worksheet['!cols'] = columnWidths;

              XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos');

              // Generar el archivo Excel
              const excelBuffer = XLSX.write(workbook, {
                type: 'array',
                bookType: 'xlsx',
              });

              const blob = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              });

              const url = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.download = `Archivo para débitos ADDI - Presentación: ${fechas.fechaPresentacion} - Vencimiento: ${fechas.fechaVencimiento}.xlsx`;
              link.click();
              URL.revokeObjectURL(url);
              let arrayDatos = [
                clientes.map((c) => ({
                  clienteDebitoId: c.clienteDebitoId,
                  importeDebitoAdhesion: c.importeDebitoAdhesion,
                  cbu: c.cbu,
                  personaId: c.personaId,
                })),
                {
                  fechaPresentacion: fechas.fechaPresentacion.valueOf(),
                  fechaVencimiento: fechas.fechaVencimiento.valueOf(),
                },
              ];
              dispatch(addAdhesionDebito(arrayDatos)).unwrap().then(console.log).catch(console.log);
              setClientes([]);
              setCampos([]);
              setNumberImputs([]);
            }
            return (
              <Fragment>
                <Dialog onClose={closeModalConfirmacion} open={modalConfirmacion} maxWidth="sm">
                  <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Confirmar:</DialogTitle>
                  <DialogContent dividers>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography>
                          ¿Seguro quiere crear la nueva adhesión? Esta acción no podrá deshacerse.
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>
                          Ha seleccionado: {selectedRows.filter((r) => r.selected === true).length} clientes.
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        El importe total de la adhesión será de: $ {moneyFormat(importeTotalAdhesion)}.
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <DialogActions style={{ marginTop: '10px', marginLeft: '5px' }}>
                    <Button
                    disabled={fetching > 0}
                      variant="outlined"
                      onClick={closeModalConfirmacion}
                      sx={{ marginRight: '5px', marginButtom: '15px', fontWeight: "bold" }}>
                      {'Cancelar'}
                    </Button>
                    <Button
                    disabled={fetching > 0}
                      variant="contained"
                      onClick={handleCreate}
                      sx={{ marginRight: '5px', marginButtom: '15px', fontWeight: "bold", color: "white" }}>
                      {'Aceptar'}
                    </Button>
                  </DialogActions>
                </Dialog>
              </Fragment>
            );
          };
          return (
            <Fragment>
              <Dialog onClose={closeAdhesionForm} open={showAdhesionForm} maxWidth="lg">
                <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Crear nueva adhesión:</DialogTitle>
                <DialogContent dividers>
                  <Box fullWidth sx={{ display: 'flex', flexWrap: 'wrap' }}>
                    <Grid container spacing={0}>
                      <Grid item xs={3} sx={{ mt: 1, mr: 1 }}>
                        <FormControlLabel
                          value="Repetir clientes de la última adhesión:"
                          control={
                            <Checkbox
                              checked={checked}
                              onChange={handleCheck}
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          }
                          label="Repetir clientes de la última adhesión:"
                          labelPlacement="start"
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <FormControl sx={{ mt: 1, mb: 1.5, mr: 1 }} variant="outlined">
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                              required
                              label="Fecha presentacion"
                              inputFormat="DD/MM/YYYY"
                              minDate={dayjs()}
                              shouldDisableDate={shouldDisableDate}
                              value={fechas.fechaPresentacion}
                              onChange={(v) =>
                                setFechas({
                                  fechaPresentacion: v,
                                  fechaVencimiento: v.add(4, 'days'),
                                })
                              }
                              renderInput={(params) => <TextField {...params} />}
                              slotProps={{
                                textField: {
                                  required: true,
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </FormControl>
                      </Grid>
                      <Grid item xs={3}>
                        <FormControl sx={{ mt: 1, mb: 1.5 }} variant="outlined">
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                              required
                              label="Fecha vencimiento"
                              inputFormat="DD/MM/YYYY"
                              minDate={fechas.fechaPresentacion.add(4, 'days')}
                              shouldDisableDate={shouldDisableDate}
                              value={fechas.fechaVencimiento}
                              onChange={(v) => setFechas({ ...fechas, fechaVencimiento: v })}
                              renderInput={(params) => <TextField {...params} />}
                              slotProps={{
                                textField: {
                                  required: true,
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <DataGridPro
                          fullWidth
                          pagination
                          sx={{ height: '60vh', width: '100%' }}
                          getRowId={(r) => r.clienteDebitoId}
                          initialState={{
                            sorting: {
                              sortModel: [{ field: 'ID', sort: 'desc' }],
                            },
                            columns: {
                              columnVisibilityModel: {
                                // Hide columns status and traderName, the other columns will remain visible
                                clienteDebitoId: false,
                              },
                            },
                          }}
                          rows={campos}
                          columns={columns}
                          disableColumnMenu
                          disableSelectionOnClick
                          experimentalFeatures={{ newEditingApi: true }}
                          components={{
                            Toolbar: () => {
                              return (
                                <GridToolbarContainer>
                                  <GridToolbarColumnsButton></GridToolbarColumnsButton>{' '}
                                  <GridToolbarFilterButton></GridToolbarFilterButton>{' '}
                                  <GridToolbarDensitySelector></GridToolbarDensitySelector>
                                </GridToolbarContainer>
                              );
                            },
                          }}
                          componentsProps={{
                            toolbar: {
                              showQuickFilter: true,
                              quickFilterProps: { debounceMs: 500 },
                              export: false,
                            },
                          }}
                          gridLinesVisibility="None"
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ color: 'error.main' }}>
                        {errores.length > 0 &&
                          errores.map((error, i) => (
                            <p style={{ marginLeft: '8px' }} key={'errAdhesion' + i}>
                              - {error}
                            </p>
                          ))}
                      </Grid>
                    </Grid>
                  </Box>
                </DialogContent>
                <DialogActions style={{ marginTop: '10px', marginLeft: '5px' }}>
                  <Button disabled={fetching > 0} variant="outlined" onClick={closeAdhesionForm} sx={{ fontWeight: "bold" }}>
                    {'Cancelar'}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    sx={{ marginRight: '5px', marginButtom: '15px', fontWeight: "bold", color: "white" }}
                    disabled={selectedRows.filter((r) => r.selected === true).length === 0 || fetching > 0}>
                    {'Aceptar'}
                  </Button>
                </DialogActions>
              </Dialog>
              <ModalConfirmacion></ModalConfirmacion>
            </Fragment>
          );
        };
        let rows = (adhesionesDebito || [])
          .filter((a) => a.eliminado !== true)
          .sort((a, b) => b.adhesionDebitoId - a.adhesionDebitoId)
          .map((r) => ({
            ...r,
            importeTotalAdhesion: r.importeTotalAdhesion / 100,
          }));
        const columns = [
          { field: 'adhesionDebitoId', headerName: 'Adhesion ID', width: 100 },
          {
            field: 'fechaPresentacion',
            headerName: 'Fecha de presentacion',
            width: 200,
            valueGetter: (v) => getFormatoFecha(getFecha(v.row.fechaPresentacion)),
            sortComparator: fechaSortComparator,
          },
          {
            field: 'fechaVencimiento',
            headerName: 'Fecha de Vencimiento',
            width: 200,
            valueGetter: (v) => getFormatoFecha(getFecha(v.row.fechaVencimiento)),
            sortComparator: fechaSortComparator,
          },
          {
            field: 'cantidadRegistros',
            headerName: 'Cantidad de clientes',
            width: 200,
          },
          {
            field: 'importeTotalAdhesion',
            headerName: 'Importe Total',
            width: 200,
            renderCell: (v) => ('$' + moneyFormat(v.row.importeTotalAdhesion)),
          }, //sortComparator: importeSortComparator
          {
            field: 'actions',
            headerName: 'Acciones',
            width: 200,
            type: 'actions',
            renderCell: (v) => (
              <>

                <GridActionsCellItem
                  key={v.row.adhesionDebitoId + '-verDetallesGridAction'}
                  disabled={currentUser?.permisos?.includes('readCobranzas') ? false : true}
                  color={'primary'}
                  onClick={() => handleDetalle(v.row.adhesionDebitoId)}
                  icon={
                    <GridAction
                      label={'Ver Detalles'}
                      key={'cobranza-adhesion-' + v.row.adhesionDebitoId}
                      Icon={VisibilityIcon}
                    />
                  }
                />
                <GridActionsCellItem
                  key={v.row.adhesionDebitoId + '-borrarGridAction'}
                  disabled={currentUser?.permisos?.includes('writeCobranzas') ? false : true}
                  color={'danger'}
                  onClick={() => {
                    setSelectedAdhesiones(v.row);
                    setShowBorrarAdhesion(true);
                  }}
                  icon={
                    <GridAction
                      label={'Eliminar'}
                      key={'cobranza-adhesion-' + v.row.adhesionDebitoId}
                      Icon={DeleteIcon}
                    />
                  }
                />
              </>
            ),
          },
        ];
        const BtnBar = (props) => {
          return (
            <Fragment>
              <Button
                disabled={fetching > 0}
                variant="contained"
                sx={{ height: '4vh', width: '15%', fontWeight: 'bold', margin: '0.4em' }}
                onClick={() => setShowAdhesionForm(true)}>
                Nuevo <AddIcon />
              </Button>
              <AdhesionForm></AdhesionForm>
            </Fragment>
          );
        };
        return (
          <Fragment>

            <DetalleModal></DetalleModal>
            <BorrarAdhesionForm></BorrarAdhesionForm>
            <Box fullWidth>
              <DataGridPro
                fullWidth
                pagination
                sx={{ height: '70vh', width: '100%' }}
                getRowId={(r) => r.adhesionDebitoId}
                rows={rows}
                columns={columns}
                pageSize={100}
                rowsPerPageOptions={[5]}
                experimentalFeatures={{ newEditingApi: true }}
                components={{
                  Toolbar: () => {
                    return <Fragment>
                      <GridToolbarContainer>
                        <Grid conteiner
                          rowSpacing={0} sx={{
                            display: "inline-flex",
                            justifyContent: "space-between",
                            alignItems: "strech",
                            width: "100%",
                          }}>
                          {currentUser?.permisos?.includes('writeCobranzas') ? <BtnBar /> : null}
                          <Grid sx={{ width: "100%", marginLeft: '1em' }}>
                            <GridToolbarColumnsButton /><GridToolbarFilterButton /> <GridToolbarDensitySelector />
                            {currentUser?.permisos?.includes('export-data') ? <> <GridToolbarExport /> </>
                              : ''}
                          </Grid>
                          <GridToolbarQuickFilter />
                        </Grid>
                      </GridToolbarContainer>
                    </Fragment>
                  }
                }}
                componentsProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                loading={fetching > 0}
              />
            </Box>
          </Fragment>
        );
      }
      //------------------------CLIENTES
      function ClientesDebito() {
        //-------------------Borrar Clientes Form
        const [showBorrarClienteForm, setShowBorrarClienteForm] =
          useState(false);
        const closeBorrarClienteForm = () => setShowBorrarClienteForm(false);
        let rows = (clientesDebito || [])
          .filter((c) => c.eliminado === false)
          .map((c) => ({
            ...c,
            tipoContrato: getClaseContrato(c.contratoId),
            CBU:
              getCbu(c.personaId) === "" ? "-" : getCbu(c.personaId).toString(),
          }));
        const BorrarClienteForm = (props) => {
          function handleBorrar() {
            dispatch(deleteClientesDebito([showBorrarClienteForm.clienteDebitoId]))
              .unwrap()
              .then(console.log)
              .catch(console.log);
            setShowBorrarClienteForm(null);
          }
          return (
            <Fragment>
              <Dialog
                onClose={closeBorrarClienteForm}
                open={showBorrarClienteForm}
                maxWidth="md"
              >
                <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>
                  Borrar cliente:
                </DialogTitle>
                <DialogContent dividers>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography>
                        ¿Seguro quiere borrar el siguiente cliente del débito directo?
                      </Typography>
                    </Grid>
                    <List sx={{ paddingLeft: "10px", paddingRight: "10px" }}>
                      <ListItem>
                        <ListItemIcon>
                          <AccountBalanceIcon></AccountBalanceIcon>
                        </ListItemIcon>
                        <ListItemText>
                          Persona ID: {showBorrarClienteForm?.personaId} - Nombre:{" "}
                          {showBorrarClienteForm?.nombreAdherente} - Contrato ID:{" "}
                          {showBorrarClienteForm?.contratoId} - Tipo:{" "}
                          {getClaseContrato(showBorrarClienteForm?.contratoId)}{" "}
                        </ListItemText>
                      </ListItem>


                    </List>

                    <Grid item xs={12}></Grid>
                    <Grid item xs={12}>
                      <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                        <Button
                        disabled={fetching > 0}
                          variant="contained"
                          onClick={handleBorrar}
                          sx={{ marginRight: "5px", marginButtom: "15px" }}
                        >
                          {"Aceptar"}
                        </Button>
                        <Button
                        disabled={fetching > 0}
                          variant="outlined"
                          onClick={closeBorrarClienteForm}
                          sx={{ marginRight: "5px", marginButtom: "15px" }}
                        >
                          {"Cancelar"}
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                </DialogContent>
              </Dialog>
            </Fragment>
          );
        };
        const columns = [
          {
            field: "clienteDebitoId",
            headerName: "Cliente Debito ID",
            width: 70,
          },
          { field: "contratoId", headerName: "Contrato ID", width: 70 },
          { field: "tipoContrato", headerName: "Tipo contrato", width: 250 },
          { field: "personaId", headerName: "Persona ID", width: 70 },
          { field: "nombreAdherente", headerName: "Nombre Cliente", width: 200 },
          {
            field: "CBU",
            headerName: "CBU",
            width: 150,
            valueGetter: (v) => v.row.CBU.toString(),
          },
          { field: "partida", headerName: "Partida", width: 150 },
          {
            field: "fechaEdicion",
            headerName: "Fecha creación",
            width: 110,
            valueGetter: (v) => getFormatoFecha(getFecha(v.row.fechaEdicion)),
            sortComparator: fechaSortComparator,
          },
          {
            field: 'actions', headerName: 'Acciones', width: 100, type: 'actions', renderCell: v =>
              <>
                <GridActionsCellItem key={v.row.clienteDebitoId + '-borrarGridAction'} disabled={currentUser?.permisos?.includes("writeCobranzas") ? false : true} color={'danger'} onClick={() => setShowBorrarClienteForm(v.row)} icon={<GridAction label={'Eliminar'} key={'cobranza-cliente-' + v.row.clienteDebitoId} Icon={DeleteIcon} color={'danger'} />} />
              </>
          }
        ];

        const BtnBar = (props) => {
          const [showClienteForm, setShowClienteForm] = useState(false);
          const openClienteForm = () => setShowClienteForm(true);
          const closeClienteForm = () => setShowClienteForm(false);

          //   //-------------------- Formulario
          const ClienteForm = (props) => {
            const [selectedRows, setSelectedRows] = useState([]);
            let filtroContratos = rows
              .filter((r) => r.eliminado === false)
              .map((r) => r.contratoId);
            let contratosFiltrados = (
              contratos || []
            ).filter((c) => !filtroContratos.includes(c.contratoId));
            let rowsClientes = contratosFiltrados.map((c) => ({
              contratoId: c.contratoId,
              personaId: getTitularidad(c.contratoId),
              nombreAdherente: getNombreAdherente(getTitularidad(c.contratoId)),
              partida:
                "0".repeat(11 - c.contratoId.toString().length) +
                c.contratoId.toString(),
              referenciaEmpresa:
                c.contratoId + "-" + getTitularidad(c.contratoId),
            }));
            const [clientes, setClientes] = useState([...rowsClientes]);
            const TitularesCell = (v) => {
              let titulares = (
                titularidades || []
              ).filter((t) => t.contratoId === v.row.contratoId);
              const [titular, setTitular] = useState(
                clientes.find((c) => c.contratoId === v.row.contratoId)
                  .personaId
              );
              const handleChange = (e) => {
                setClientes([
                  ...clientes.map((c) =>
                    c.contratoId === v.row.contratoId
                      ? {
                        ...c,
                        personaId: e.target.value,
                        nombreAdherente: getNombreAdherente(e.target.value),
                        referenciaEmpresa:
                          v.row.contratoId + "-" + e.target.value,
                      }
                      : c
                  ),
                ]);
                setTitular(e.target.value);
              };
              return titulares.length > 1 ? (
                <FormControl fullWidth>
                  <Select
                    sx={{
                      boxShadow: "none",
                      ".MuiOutlinedInput-notchedOutline": { border: 0 },
                      width: "100%",
                    }}
                    label="Cliente"
                    name="personaId"
                    value={titular}
                    onChange={handleChange}
                  >
                    {getDropdownOptions(v.row.contratoId)}
                  </Select>
                </FormControl>
              ) : (
                <Typography sx={{ marginLeft: "10px" }}>
                  {getLabel(titular)}
                </Typography>
              );
            };
            //----------------Función que se llama al apretar el botón 'Aceptar' y raliza validaciones.
            function handleSubmit() {
              let clientesFiltrados = [...clientes].filter((c) =>
                selectedRows.includes(c.contratoId)
              );
              //clientesFiltrados.map(c => delete c.contratoId)
              dispatch(addClientesDebito(clientesFiltrados))
                .unwrap()
                .then(console.log)
                .catch(console.log);
              setClientes([]);
              setSelectedRows([]);
            }
            //----------------Columnas del formulario
            const columns = [
              {
                field: "contratoId",
                headerName: "Contrato Id",
                width: 200,
                valueGetter: (v) => parseInt(v.row.contratoId),
              },
              {
                headerName: "Tipo de contrato",
                width: 250,
                valueGetter: (v) =>
                  v.row.contratoId
                    ? getClaseContrato(parseInt(v.row.contratoId))
                    : "-",
              },
              {
                field: "personaId",
                headerName: "Cliente",
                width: 300,
                renderCell: TitularesCell,
              },
            ];
            return (
              <Fragment>
                <Dialog
                  onClose={closeClienteForm}
                  open={showClienteForm}
                  maxWidth="lg"
                >
                  <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Seleccionar los nuevos clientes:</DialogTitle>
                  <DialogContent dividers>
                    <Box fullWidth
                    >
                      <DataGridPro
                        pagination
                        sx={{ height: '65vh', width: '100%' }}
                        getRowId={(r) => r.contratoId}
                        initialState={{
                          sorting: {
                            sortModel: [{ field: "ID", sort: "desc" }],
                          },
                          columns: {
                            columnVisibilityModel: {
                              // Hide columns status and traderName, the other columns will remain visible
                              titularidadContratosId: false,
                            },
                          },
                        }}
                        rows={rowsClientes}
                        columns={columns}
                        disableColumnMenu
                        checkboxSelection
                        onRowSelectionModelChange={(newRowSelectionModel) => {
                          setSelectedRows(newRowSelectionModel);
                        }}
                        rowSelectionModel={selectedRows}
                        disableSelectionOnClick
                        experimentalFeatures={{ newEditingApi: true }}
                        components={{
                          Toolbar: () => {
                            return (
                              <GridToolbarContainer>
                                <GridToolbarColumnsButton></GridToolbarColumnsButton>{" "}
                                <GridToolbarFilterButton></GridToolbarFilterButton>{" "}
                                <GridToolbarDensitySelector></GridToolbarDensitySelector>
                              </GridToolbarContainer>
                            );
                          },
                        }}
                        componentsProps={{
                          toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                            export: false,
                          },
                        }}
                        gridLinesVisibility="None"
                        slotProps={{
                          toolbar: {
                            showQuickFilter: true,
                          },
                        }}
                      />
                    </Box>
                  </DialogContent>
                  <DialogActions>
                    <Button
                    disabled={fetching > 0}
                      variant="outlined"
                      onClick={closeClienteForm}
                    >
                      {"Cancelar"}
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleSubmit}
                      sx={{ marginRight: "5px", marginButtom: "15px" }}
                      disabled={selectedRows.length === 0 || fetching > 0}
                    >
                      {"Aceptar"}
                    </Button>
                  </DialogActions>
                </Dialog>
              </Fragment>
            );
          };
          return (
            <Fragment>
              <Button disabled={fetching > 0} className="mb-3" variant="contained" color='primary' sx={{ height: '4vh', width: '15%', fontWeight: 'bold', margin: '0.4em' }} onClick={() => setShowClienteForm(true)}>NUEVO<AddIcon /></Button>
              {/* <IconButton
                className="mb-3"
                variant="contained"
                color="primary"
                onClick={() => setShowClienteForm(true)}
              >
                <AddIcon />
              </IconButton> */}
              <ClienteForm></ClienteForm>
            </Fragment>
          );
        };
        return (
          <Fragment>
            <Box fullWidth>
              <BorrarClienteForm></BorrarClienteForm>
              <DataGridPro
                fullWidth
                pagination
                sx={{ height: '70vh' }}
                getRowId={(r) => r.clienteDebitoId}
                rows={rows}
                columns={columns}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      // Hide columns status and traderName, the other columns will remain visible
                      clienteDebitoId: false,
                    },
                  },
                }}
                //disableSelectionOnClick
                experimentalFeatures={{ newEditingApi: true }}
                components={{
                  Toolbar: () => {
                    return <Fragment>
                      <GridToolbarContainer>
                        <Grid conteiner
                          rowSpacing={0} sx={{
                            display: "inline-flex",
                            justifyContent: "space-between",
                            alignItems: "strech",
                            width: "100%",
                          }}>
                          {currentUser?.permisos?.includes("writeCobranzas") ? (<BtnBar></BtnBar>) : null}
                          <Grid sx={{ width: "100%", marginLeft: '1em' }}>
                            <GridToolbarColumnsButton /><GridToolbarFilterButton /> <GridToolbarDensitySelector />
                            {currentUser?.permisos?.includes('export-data') ? <> <GridToolbarExport /> </>
                              : ''}
                          </Grid>
                          <GridToolbarQuickFilter />
                        </Grid>
                      </GridToolbarContainer>
                    </Fragment>
                  }
                }}
                componentsProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                    csvOptions: {
                      fileName: "Edilia Debito Directo Clientes",
                    },
                  },
                }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
                loading={fetching > 0}
              />
            </Box>
          </Fragment>
        );
      }
      //-----------------------INGRESOS
      function IngresosDebito() {
        let rows = [...(ingresosDebito || [])]?.sort(
          (a, b) => b.ingresoDebitoId - a.ingresoDebitoId
        )?.map(r => {
          let detalles = (detallesIngreso || [])
            .filter((d) => d.ingresoDebitoId === r.ingresoDebitoId)
          let aceptados = detalles?.filter(d => d.codigoError === '000');
          let rechazados = detalles?.filter(d => d.codigoError !== '000');
          let importesAcep = 0;
          let importesRech = 0;
          aceptados?.forEach(a => importesAcep += parseFloat(a.importeDebitoIngreso))
          rechazados?.forEach(a => importesRech += parseFloat(a.importeDebitoIngreso))
          return {
            ...r,
            aceptados: aceptados?.length,
            rechazados: rechazados?.length,
            importeAceptado: importesAcep,
            importesRechazado: importesRech
          }
        })
        const [detalleModal, setDetalleModal] = useState(false);
        const [showDetalleModal, setShowDetalleModal] = useState(false);
        const openDetalleModal = () => setShowDetalleModal(true);
        const closeDetalleModal = () => setShowDetalleModal(false);
        //Funciónes de Botones DataGrid
        function handleDetalle(id) {
          setDetalleModal(id);
          openDetalleModal();
        }
        function getEstadoIngreso(codigo) {
          let estado = codigo
          switch (codigo) {
            case '000':
              estado = 'Aceptado';
              break;
            case 'R03':
              estado = 'Cuenta inexistente';
              break;
            case 'R04':
              estado = 'N° de cuenta inválido.';
              break;
            case 'R05':
              estado = 'Canal inválido.';
              break;
            case 'R10':
              estado = 'Saldo insuf.';
              break;
            case 'R11':
              estado = 'Cuenta bloqueada';
              break;
            case 'R13':
              estado = 'Sucursal/Entidad/Destino inexistente';
              break;
            case 'R14':
              estado = 'N° CUIT erróneo.';
              break;
            case 'R17':
              estado = 'Error de formato';
              break;
            case 'R18':
              estado = 'Fecha compensación errónea.';
              break;
            case 'R19':
              estado = 'Importe erróneo.';
              break;
            case 'R20':
              estado = 'Moneda distinta a cuenta de débito.';
              break;
            case 'R22':
              estado = 'Solicitud de beneficiario.';
              break;
            case 'R23':
              estado = 'Sucursal no habilitada.';
              break;
            case 'R24':
              estado = 'Transacción duplicada.';
              break;
            case 'R25':
              estado = 'Error en registro adicional.';
              break;
            case 'R26':
              estado = 'Error en campo mandatario.';
              break;
            case 'R27':
              estado = 'Error en contador de registro.';
              break;
            default:
              estado = 'Rechazado'
              break;
          }
          return estado
        }
        const DetalleModal = (props) => {
          let detalles = (detallesIngreso || [])
            .filter((d) => d.ingresoDebitoId === detalleModal)
            ?.map((c) => ({
              ...c,
              nombreAdherente: getNombreAdherente(c.personaId),
              estado: getEstadoIngreso(c.codigoError)
            }));
          let rows = detalles || [];
          const columns = [
            { field: "contratoId", headerName: "Contrato ID", width: 150 },
            {
              headerName: "Tipo Contrato",
              width: 350,
              valueGetter: (v) => getClaseContrato(parseInt(v.row.contratoId)),
            },
            {
              field: "importeDebitoIngreso",
              headerName: "Importe",
              width: 250,
              valueGetter: (v) => '$' + moneyFormat(parseFloat(v.row.importeDebitoIngreso) / 100),
              sortComparator: importeSortComparator,
            },
            { field: "estado", headerName: "Resultado", width: 100 },
          ];
          return (
            <Fragment>
              <Dialog
                onClose={closeDetalleModal}
                open={showDetalleModal}
                maxWidth="lg"
              >
                <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>
                  Detalles del ingreso N° {detalleModal}:
                </DialogTitle>
                <DialogContent dividers>
                  <Box fullWidth
                  >
                    <DataGridPro
                      pagination
                      fullWidth
                      sx={{ height: '70vh' }}
                      getRowId={(r) => r.detalleIngresoId}
                      autoHeight
                      initialState={{
                        sorting: {
                          sortModel: [{ field: "ID", sort: "asc" }],
                        },
                      }}
                      rows={rows || []}
                      columns={columns}
                      pageSize={100}
                      rowsPerPageOptions={[8]}
                      experimentalFeatures={{ newEditingApi: true }}
                      components={{ Toolbar: GridToolbar }}
                      componentsProps={{
                        toolbar: {
                          showQuickFilter: true,
                          quickFilterProps: { debounceMs: 500 },
                        },
                      }}
                      slotProps={{
                        toolbar: {
                          showQuickFilter: true,
                        },
                      }}
                      loading={fetching > 0}
                    />
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Button disabled={fetching > 0} onClick={() => setShowDetalleModal(false)}>
                    Volver
                  </Button>
                </DialogActions>
              </Dialog>
            </Fragment>
          );
        };
        const columns = [
          { field: "ingresoDebitoId", headerName: "Ingreso ID", width: 100 },
          {
            field: "fechaEmision",
            headerName: "Fecha de emisión",
            width: 150,
            valueGetter: (v) => getFormatoFecha(v.row.fechaEmision),
            sortComparator: fechaSortComparator,
          },
          {
            field: "fechaEdicion",
            headerName: "Carga en el sistema",
            width: 150,
            valueGetter: (v) => getFormatoFecha(getFecha(v.row.fechaEdicion)),
            sortComparator: fechaSortComparator,
          },
          {
            field: "cantidadRegristros",
            headerName: "Presentados",
            width: 100,
            valueGetter: (v) => parseInt(v.row.cantidadRegistros),
          },
          {
            field: "aceptados",
            headerName: "Aceptados",
            width: 100,
            valueGetter: (v) => parseInt(v.row.aceptados),
          },
          {
            field: "rechazados",
            headerName: "Rechazados",
            width: 100,
            valueGetter: (v) => parseInt(v.row.rechazados),
          },
          {
            field: "importeTotalIngreso",
            headerName: "Importe Esperado",
            width: 150,
            valueGetter: (v) =>
              ('$' + moneyFormat(v.row.importeTotalIngreso / 100)),
            sortComparator: importeSortComparator,
          },
          {
            field: "importeAceptado",
            headerName: "Importe Ingresado",
            width: 150,
            valueGetter: (v) =>
              ('$' + moneyFormat(parseFloat(v.row.importeAceptado / 100))),
            sortComparator: importeSortComparator,
          },
          {
            field: 'actions', headerName: 'Acciones', width: 100, type: 'actions', renderCell: v =>
              <>
                <GridActionsCellItem key={v.row.ingresoDebitoId + '-verDetallesIngresoGridAction'} disabled={currentUser?.permisos?.includes("readCobranzas") ? false : true} color={'primary'} onClick={() => handleDetalle(v.row.ingresoDebitoId)} icon={<GridAction label={'Ver Detalles'} key={'cobranza-ingreso-' + v.row.ingresoDebitoId} Icon={VisibilityIcon} />} />
              </>
          }
        ];
        const BtnBar = (props) => {
          //Lectura de Ingreso
          function handleChange(e) {
            const file = e.target.files[0];

            // Verificar si el archivo tiene la extensión .deb
            if (file.name.endsWith('.deb')) {
              const fileReader = new FileReader();
              fileReader.readAsText(file);

              fileReader.onload = (e) => {
                const arrayFile = fileReader.result.split('\n');
                arrayFile.push(file.name); // Agregar el nombre del archivo al array

                // Procesar el archivo
                dispatch(addIngresosDebito(arrayFile))
                  .unwrap()
                  .then(console.log)
                  .catch(console.error);
              };

              fileReader.onerror = (e) => {
                console.error('Error al leer el archivo:', fileReader.error);
              };
            } else {
              console.error('El archivo seleccionado no tiene la extensión .deb');
            }
          };
          return (
            <div
              style={{
                position: "relative",
                width: '15%',
                height: '4vh',
                margin: '0.4em'
              }}
            >
              <Button
              disabled={fetching > 0}
                size="small"
                sx={{ height: '4vh', minWidth: 130, fontWeight: 'bold', }}
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  zIndex: "0",
                }}
                variant="contained"
              >
                Cargar<FileUploadIcon></FileUploadIcon>
              </Button>
              <input
                style={{
                  opacity: "0",
                  position: "absolute",
                  top: "0",
                  left: "0",
                  width: "20vh",
                  height: '4vh',
                  zIndex: "2",
                }}
                type="file"
                onChange={handleChange}
                className="input-field"
                id="file"
                value={""}
              />
            </div>
          );
        };
        return (
          <Fragment>
            <Box
              fullWidth
            >
              <DataGridPro
                pagination
                fullWidth
                sx={{ height: '70vh' }}
                getRowId={(r) => r.ingresoDebitoId}
                rows={rows || []}
                columns={columns}
                experimentalFeatures={{ newEditingApi: true }}
                components={{
                  Toolbar: () => {
                    return <Fragment>
                      <GridToolbarContainer>
                        <Grid conteiner
                          rowSpacing={0} sx={{
                            display: "inline-flex",
                            justifyContent: "space-between",
                            alignItems: "strech",
                            width: "100%",
                          }}>
                          {currentUser?.permisos?.includes("writeCobranzas") ? <BtnBar /> : null}
                          <Grid sx={{ width: "100%", marginLeft: '1.5%' }}>
                            <GridToolbarColumnsButton /><GridToolbarFilterButton /> <GridToolbarDensitySelector />
                            {currentUser?.permisos?.includes('export-data') ? <> <GridToolbarExport /> </>
                              : ''}
                          </Grid>
                          <GridToolbarQuickFilter />
                        </Grid>
                      </GridToolbarContainer>
                    </Fragment>
                  }
                }}
                componentsProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
                loading={fetching > 0}
              />
            </Box>
            <DetalleModal></DetalleModal>
          </Fragment>
        );
      }
      //-------------------------------------Tab Panel
      function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
          <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}>
            {value === index && (
              <Box sx={{ p: 3 }}>
                <Typography >{children}</Typography>
              </Box>
            )}
          </div>
        );
      }
      const ModalTabs = () => {
        function a11yProps(index) {
          return {
            'id': `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
          };
        }
        const handleChange = (event, newValue) => {
          setValue(newValue);
        };

        return (
          <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab sx={{ fontWeight: "bold" }} label="Clientes" {...a11yProps(0)} />
                <Tab sx={{ fontWeight: "bold" }} label="Adhesiones" {...a11yProps(1)} />
                <Tab sx={{ fontWeight: "bold" }} label="Ingresos" {...a11yProps(2)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <ClientesDebito />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <AdhesionesDebito />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <IngresosDebito />
            </TabPanel>
          </>
        );
      };
      return <ModalTabs />;
    };
    //Registros y Rendiciones --------
    const RegistrosyRendicionesTable = (props) => {
      //----------Secciones
      //-------------------------------------CVUS
      function CVUS(props) {
        function filterArray(arr) {
          const seen = new Set();
          const result = [];
          for (const obj of arr) {
            const key = `${obj.numeroCliente}-${obj.tipoOperacion}`;
            if (!seen.has(key)) {
              seen.add(key);
              result.push(obj);
            }
          }
          return result;
        }
        let rows = (cvus || []);
        let clientes = (campos || []).filter(
          (c) =>
            !rows.some(
              (r) => parseInt(r.contratoId) === parseInt(c.numeroCliente)
            )
        );
        let clientesFiltrados = clientes.filter((c) => {
          const contratoIds = rows.map((row) => row.contratoId);
          return !contratoIds.includes(parseInt(c.numeroCliente));
        });
        clientesFiltrados = filterArray(clientesFiltrados)?.map((c) => ({
          cvuId: "id" + c.numeroCliente + c.campoId + c.registroId,
          cvu: "No se ha cargado un CVU",
          contratoId: parseInt(c.numeroCliente),
          fechaAlta: "-",
          fechaEdicion: "-",
        }));
        rows = clientesFiltrados
          .concat(rows)
          .sort((a, b) => parseInt(a.contratoId) - parseInt(b.contratoId));
        const RenderTitularidad = (params) => {
          const [anchorEl, setAnchorEl] = useState(null);
          const [verTitulares, setVerTitulares] = useState(false);
          function handleClick(event) {
            setAnchorEl(event.currentTarget);
            setVerTitulares(true);
          }
          function handleClose() {
            setAnchorEl(null);
            setVerTitulares(false);
          }
          let personasAsArray = (personas || []);
          let titulares = (titularidades || []).filter(
            (t) => t.contratoId === params.row.contratoId
          );
          let personasT = [];
          for (let i = 0; i < titulares.length; i++) {
            personasT.push(
              personasAsArray.find(
                (p) => p.personaId === titulares[i].personaId
              )
            );
          }
          return (
            <Fragment>
              <Button aria-haspopup="true" onClick={handleClick}>
                {personasT.length}
              </Button>

              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={verTitulares}
                onClose={handleClose}
                onMouseLeave={handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <List>
                  {personasT.map((p, i) => (
                    <ListItem
                      key={"MenuItemTitularidad" + i}
                      onClick={handleClose}
                    >
                      <Typography>{getLabel(p.personaId)}</Typography>
                    </ListItem>
                  ))}
                </List>
              </Menu>
            </Fragment>
          );
        };
        const columns = [
          {
            field: "contratoId",
            headerName: "Contrato ID",
            width: 100,
            valueGetter: (v) => parseInt(v.row.contratoId),
          },
          {
            headerName: "Tipo de Contrato",
            width: 300,
            valueGetter: (v) =>
              v.row.contratoId
                ? getClaseContrato(parseInt(v.row.contratoId))
                : "-",
          },
          {
            field: "cvu",
            headerName: "CVU",
            width: 300,
            valueGetter: (v) => v.row.cvu.toString(),
          },
          {
            field: "fechaAlta",
            headerName: "Fecha de alta",
            width: 150,
            valueGetter: (v) =>
              v.row.fechaAlta === "-" ? "-" : getFormatoFecha(v.row.fechaAlta),
            sortComparator: fechaSortComparator,
          },
          {
            field: "fechaEdicion",
            headerName: "Fecha de carga",
            width: 150,
            valueGetter: (v) =>
              v.row.fechaAlta === "-"
                ? "-"
                : getFormatoFecha(getFecha(v.row.fechaEdicion)),
            sortComparator: fechaSortComparator,
          },
          {
            field: "titularidades",
            headerName: "Titulares",
            width: 100,
            renderCell: RenderTitularidad,
          },
        ];
        const BtnBar = (props) => {
          const [showValidation, setShowValidation] = useState(false);
          const [validation, setValidation] = useState("");
          const closeValidation = () => setShowValidation(false);
          //Lectura de CVUs
          function handleChange(e) {
            let rFile = e.target.files[0];
            let fileReader = new FileReader();
            fileReader.readAsText(rFile);
            fileReader.onload = (e) => {
              let arrayFile = fileReader.result.split("\n");
              for (let i = 0; i < arrayFile.length; i++) {
                let cvu = arrayFile[i].substring(78, 100);
                let cvuDoble = rows.find((r) => r.cvu === cvu);
                if (cvuDoble !== undefined && cvuDoble !== null) {
                  arrayFile.splice(i, 1);
                  i = i - 1;
                }
              }
              if (
                arrayFile.length === 0 ||
                arrayFile[0].substring(0, 1) !== "H"
              ) {
                arrayFile.length === 0
                  ? setValidation("Archivo repetido")
                  : setValidation("Archivo incorrecto");
                setShowValidation(true);
              } else {
                dispatch(addCvusCobranza(arrayFile))
                  .unwrap()
                  .then(console.log)
                  .catch(console.log);
              }
            };
            fileReader.onerror = (e) => {
              console.log(fileReader.result);
            };
          }
          const ValidationFile = (props) => {
            return (
              <>
                <Dialog
                  onClose={closeValidation}
                  open={showValidation}
                  maxWidth="md"
                >
                  <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>
                    {validation === "Archivo repetido"
                      ? "Archivo repetido:"
                      : "Archivo incorrecto:"}
                  </DialogTitle>
                  <DialogContent dividers>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography>
                          {validation === "Archivo repetido"
                            ? "Todos los CVUs del archivo ya se encuentran cargados en el sistema"
                            : "El archivo ingresado es incorrecto. Por favor ingrese el archivo correcto."}
                        </Typography>
                      </Grid>

                      <Grid item xs={12}></Grid>
                      <Grid item xs={12}>
                        <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                          <Button
                          disabled={fetching > 0}
                            variant="outlined"
                            onClick={closeValidation}
                            sx={{ marginRight: "5px", marginButtom: "15px" }}
                          >
                            {"Cancelar"}
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                  </DialogContent>
                </Dialog>
              </>
            );
          };
          return (
            <Fragment>
              <div
                style={{
                  position: "relative",
                  width: '15%',
                  height: '4vh',
                  margin: '0.4em'
                }}
              >
                <Button
                disabled={fetching > 0}
                  size="small"
                  sx={{ height: '4vh', minWidth: 130, fontWeight: 'bold', }}
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    zIndex: "0",
                  }}
                  variant="contained"
                >
                  Cargar <FileUploadIcon></FileUploadIcon>
                </Button>
                <input
                  style={{
                    opacity: "0",
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "20vh",
                    height: '4vh',
                    zIndex: "2",
                  }}
                  type="file"
                  onChange={handleChange}
                  className="input-field"
                  id="file"
                  value={""}
                />
              </div>
            </Fragment>
          );
        };
        return (
          <Fragment>
            <Box
              fullWidth
            >
              <DataGridPro
                fullWidth
                getRowId={(r) => r.cvuId}
                initialState={{
                  sorting: {
                    sortModel: [{ field: "ID", sort: "desc" }],
                  },
                }}
                rows={rows || []}
                columns={columns}
                pagination
                sx={{ height: '70vh' }}
                experimentalFeatures={{ newEditingApi: true }}
                components={{
                  Toolbar: () => {
                    return <Fragment>
                      <GridToolbarContainer>
                        <Grid conteiner
                          rowSpacing={0} sx={{
                            display: "inline-flex",
                            justifyContent: "space-between",
                            alignItems: "strech",
                            width: "100%",
                          }}>
                          {currentUser?.permisos?.includes("writeCobranzas") ? <BtnBar /> : null}
                          <Grid sx={{ width: "100%", marginLeft: '1.5%' }}>
                            <GridToolbarColumnsButton /><GridToolbarFilterButton /> <GridToolbarDensitySelector />
                            {currentUser?.permisos?.includes('export-data') ? <> <GridToolbarExport /> </>
                              : ''}
                          </Grid>
                          <GridToolbarQuickFilter />
                        </Grid>
                      </GridToolbarContainer>
                    </Fragment>
                  }
                }}
                componentsProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                    export: false,
                  },
                }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
                loading={fetching > 0}
              />
            </Box>
          </Fragment>
        );
      } // ------- FIN CVUS
      //-------------------------------------Registros
      function RegistrosCobranza() {
        let calles = [
          "Avenida Calchaquí",
          "Avenida La Plata",
          "Avenida Mitre",
          "Avenida Mosconi",
          "Avenida San Martín",
          "Avenida Vicente López",
          "Avenida 12 de Octubre",
          "Avenida 25 de Mayo",
          "Avenida 9 de Julio",
          "Calle Alberdi",
          "Calle Belgrano",
          "Calle Colón",
          "Calle Dorrego",
          "Calle España",
          "Calle French",
          "Calle Garibaldi",
          "Calle Gutiérrez",
          "Calle Hipólito Yrigoyen",
          "Calle Humberto Primo",
          "Calle Independencia",
          "Calle Ituzaingó",
          "Calle Lavalle",
          "Calle Libertad",
          "Calle Lincoln",
          "Calle Moreno",
          "Calle Pellegrini",
          "Calle Perón",
          "Calle Rivadavia",
          "Calle Rodríguez",
          "Calle Sarmiento",
          "Calle Solís",
          "Calle Sáenz Peña",
          "Calle San Juan",
          "Calle Santa Fe",
          "Calle Urquiza",
          "Calle Vélez Sarsfield",
          "Calle Vicente López y Planes",
          "Calle Zapiola",
          "Calle Zeballos",
          "Calle 1 de Mayo",
          "Calle 9 de Julio",
          "Calle 12 de Octubre",
          "Calle 25 de Mayo",
          "Calle 29 de Septiembre",
          "Calle 30 de Agosto",
          "Calle 12 de Octubre",
          "Calle 3 de Febrero",
          "Calle 9 de Julio",
          "Calle 25 de Mayo",
          "Calle 29 de Septiembre",
        ];
        let rows = [...(registros || [])].sort(
          (a, b) => parseInt(b.numeroEnvio) - parseInt(a.numeroEnvio)
        );
        const [detalleModal, setDetalleModal] = useState(false);
        const [showDetalleModal, setShowDetalleModal] = useState(false);
        const openDetalleModal = () => setShowDetalleModal(true);
        const closeDetalleModal = () => setShowDetalleModal(false);
        //Funciónes de Botones DataGrid
        function handleDetalle(id) {
          setDetalleModal(id);
          openDetalleModal();
        }
        const DetalleModal = (props) => {
          const [valueTabs, setValueTabs] = useState(0);
          function handleDownload(id) {
            let selectedRegistro = (registros).find(
              (r) => r.registroId === id
            );
            //Funciones Create
            function createHeader(r) {
              let header =
                "H" +
                r.codigoOrganismo +
                r.codigoCanal +
                r.numeroEnvio +
                r.ultimaRendicionProcesada +
                r.marcaActualizacionDeuda +
                r.marcaPublicacion +
                " ".repeat(617) +
                "\n";
              return header;
            }
            function createTrailer(r) {
              let trailer =
                "T" +
                r.importeTotal1erVencimiento +
                r.ceros +
                r.cantidadRegristroInformados +
                " ".repeat(612);
              return trailer;
            }
            let header = createHeader(selectedRegistro);
            let trailer = createTrailer(selectedRegistro);
            let body = selectedRegistro.cuerpoArchivo;
            let name =
              "PUB-30717878635-001-01-" +
              getFecha(selectedRegistro.fechaEdicion) +
              "-" +
              getHora(selectedRegistro.fechaEdicion) +
              ".txt";
            //let name = "PUB-30504287331-001-01-" + getFecha(selectedRegistro.fechaEdicion) + "-" + getHora(selectedRegistro.fechaEdicion) + ".txt";
            const blob = new Blob([header, body, trailer], {
              type: "text/plain;charset=ISO-8859-1",
            });
            const href = URL.createObjectURL(blob);
            const a = Object.assign(document.createElement("a"), {
              href,
              style: "display:none",
              download: name, //"RegistroCobranzaSantander.txt"
            });
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(href);
            a.remove();
          }
          const VistaArchivoModal = (props) => {
            function createHeader(r) {
              let header =
                "H" +
                r.codigoOrganismo +
                r.codigoCanal +
                r.numeroEnvio +
                r.ultimaRendicionProcesada +
                r.marcaActualizacionDeuda +
                r.marcaPublicacion +
                "\n";
              return header;
            }
            function createTrailer(r) {
              let trailer =
                "T" +
                r.importeTotal1erVencimiento +
                r.ceros +
                r.cantidadRegristroInformados +
                " ".repeat(612);
              return trailer;
            }
            let registro = detalleModal;
            let r = (registros).find(
              (r) => r.registroId === registro
            );
            let doc = "";
            if (detalleModal) {
              doc = createHeader(r) + r?.cuerpoArchivo + createTrailer(r);
            }
            return (
              <Fragment>
                <Typography gutterBottom>{doc}</Typography>
              </Fragment>
            );
          };
          const DetalleClientes = (props) => {
            let camposRegistro = (campos).filter(
              (c) => c.registroId === detalleModal
            );

            let rowsR = (camposRegistro || []);
            const columnsR = [
              {
                field: "numeroCliente",
                headerName: "Contrato ID",
                width: 100,
                valueGetter: (v) => parseInt(v.row.numeroCliente),
              },
              {
                headerName: "Tipo de Contrato",
                width: 250,
                valueGetter: (v) =>
                  v.row.numeroCliente
                    ? getClaseContrato(parseInt(v.row.numeroCliente))
                    : "-",
              },
              {
                field: "nombreCliente",
                headerName: "Nombre del cliente",
                width: 250,
              },
              {
                field: "CVU",
                headerName: "CVU",
                width: 250,
                valueGetter: (v) => getCVU(v.row.numeroCliente),
              },
              {
                field: "tipoOperacion",
                headerName: "Tipo de operacion",
                width: 150,
                valueGetter: (v) =>
                  v.row.tipoOperacion
                    ? getTipoOperacion(v.row.tipoOperacion)
                    : "-",
              },
            ];
            return (
              <Fragment>
                <Box fullWidth
                >
                  <DataGridPro
                    fullWidth
                    pagination
                    sx={{ height: '50vh' }}
                    getRowId={(r) => r.campoId}
                    initialState={{
                      sorting: {
                        sortModel: [{ field: "ID", sort: "asc" }],
                      },
                    }}
                    rows={rowsR || []}
                    columns={columnsR}
                    //disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    components={{ Toolbar: GridToolbar }}
                    componentsProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                      },
                    }}
                  />
                </Box>
              </Fragment>
            );
          };
          function TabPanel(props) {
            const { children, value, index, ...other } = props;
            return (
              <div
                role="tabpanel"
                hidden={valueTabs !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
              >
                {valueTabs === index && (
                  <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                  </Box>
                )}
              </div>
            );
          }
          const ModalTabs = () => {
            function a11yProps(index) {
              return {
                id: `simple-tab-${index}`,
                "aria-controls": `simple-tabpanel-${index}`,
              };
            }
            const handleChange = (event, newValue) => {
              setValueTabs(newValue);
            };

            return (
              <>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    value={valueTabs}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                  >
                    <Tab label="Clientes publicados" {...a11yProps(0)} />
                    <Tab label="Vista del archivo" {...a11yProps(1)} />
                  </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                  <DetalleClientes />
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <VistaArchivoModal />
                </TabPanel>
              </>
            );
          };
          return (
            <Fragment>
              <Dialog
                onClose={closeDetalleModal}
                open={showDetalleModal}
                maxWidth="lg"
                minHeight="650px"
              >
                <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>
                  Detalles del registro N° {detalleModal}:
                </DialogTitle>
                <DialogContent dividers>
                  <Box fullWidth>
                    <ModalTabs />
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Button
                    disabled={fetching > 0}
                    component="button"
                    variant="contained"
                    size="small"
                    onClick={() => handleDownload(detalleModal)}
                  >
                    Descargar registro <FileDownloadIcon></FileDownloadIcon>
                  </Button>
                  <Button disabled={fetching > 0} onClick={() => setShowDetalleModal(false)}>
                    Volver
                  </Button>
                </DialogActions>
              </Dialog>
            </Fragment>
          );
        };
        const renderDetalles = (params) => {
          return (
            <IconButton
              component="button"
              variant="contained"
              size="small"
              onClick={() => handleDetalle(params.row.registroId)}
              color="primary"
            >
              <VisibilityIcon />
            </IconButton>
          );
        };
        const columns = [
          {
            field: "sent",
            headerName: "Procesada",
            width: 200,
            renderCell: (v) =>
              v.row.sent === null ? (
                //<GridAction label={'En Espera'} key={'cobranza-estadoEspera-' + v.row.registroId} Icon={ScheduleIcon} /> 
                <ScheduleIcon color="secondary" />
              ) : v.row.sent ? (
                //<GridAction label={'Procesada'} key={'cobranza-estadoEspera-' + v.row.registroId} Icon={CheckCircleIcon} color={'secondary'} />
                <CheckCircleIcon color="primary" />
              ) : (
                //<GridAction label={'Rechazada'} key={'cobranza-estadoEspera-' + v.row.registroId} Icon={ClearIcon} color={'danger'}/>
                <ClearIcon color="danger" />
              ),
          },
          {
            field: "numeroEnvio",
            headerName: "N° Envio",
            width: 200,
            valueGetter: (v) => parseInt(v.row.numeroEnvio),
          },
          {
            field: "fechaEdicion",
            headerName: "Fecha de publicacion",
            width: 250,
            valueGetter: (v) => getFormatoFecha(getFecha(v.row.fechaEdicion)),
            sortComparator: fechaSortComparator,
          },
          {
            field: "cantidadRegristroInformados",
            headerName: "Cantidad de clientes",
            width: 200,
            valueGetter: (v) => parseInt(v.row.cantidadRegristroInformados),
          },
          {
            field: 'actions', headerName: 'Acciones', width: 100, type: 'actions', renderCell: v =>
              <>
                <GridActionsCellItem key={v.row.registroId + '-verDetallesregistroGridAction'} disabled={currentUser?.permisos?.includes("readCobranzas") ? false : true} color={'primary'} onClick={() => handleDetalle(v.row.registroId)} icon={<GridAction label={'Ver Detalles'} key={'cobranza-registros-' + v.row.registroId} Icon={VisibilityIcon} />} />
              </>
          }
        ];
        const BtnBar = (props) => {
          const [mostrarNuevoRegistro, setMostrarNuevoRegistro] =
            useState(false);
          const closeClientesModal = () => setMostrarNuevoRegistro(false);
          const NuevoRegistro = (props) => {
            const [selectedRows, setSelectedRows] = useState([]);
            const [errores, setErrores] = useState([]);
            let contratosFiltrados = (contratos || []);
            let rowsClientes = contratosFiltrados.map((c) => ({
              numeroCliente: c.contratoId,
              clientePersonaId: getTitularidad(c.contratoId),
              tipoOperacion: "A",
              codigoMoneda: "0",
              tipoComprobante: "AP", //Anticipo
              numeroComprobante: "0", //si no hay factura lo completamos con ceros
              numeroCuota: "0", //length 4 alf
              nombreCliente: "",
              direccionCliente: "",
              descripcionLocalidad: "",
              prefijoCodigoPostal: " ", //length 1 alf
              numeroCodigoPostal:
                getCodigoPostal(getTitularidad(c.contratoId)) || 0,
              ubicacionManzanaCodigoPostal: " ", //length 4 alf
              fechaPrimerVencimiento: "00000000",
              importePrimerVencimiento: "0",
              fechaSegundoVencimiento: "00000000",
              importeSegundoVencimiento: "0",
              fechaDescuento: "00000000",
              importeProntoPago: "0",
              fechaPunitorios: "00000000", //dayjs(),
              tasaPunitorios: "0",
              marcaExcepcionCobro: "N",
              formasCobro: "          ", // leghth 10 alf será un valor determinado pero no sé cual
              numeroCuitCliente:
                getCuitCliente(getTitularidad(c.contratoId)) || 0,
              codigoIngresosBrutos: "9",
              codigoCondicionIVA: "0",

              codigoConcepto: " ", //length 3 alf
              descripcionCodigo: " ", //length 40 alf
              observacionLibre1ra: " ", //length 18 alf
              observacionLibre2da: " ", //length 15 alf
              observacionLibre3ra: " ", //length 15 alf
              observacionLibre4ta: " ", //length 15 alf
              observacionLibre5ta: " ", //length 15 alf
              canalFormasPago: " ",
              debinAliasCuentaComprador: " ",
              debinCBUCuentaComprador: " ",
              importeDebin: "0",
              parametroActualizacionDebin: "N",
              tiempoExpiracion: " ", //length 4 alf
              recurrenciaVendedor: "N",
              generacionCVU: "S",
            }));
            const [cps, setCps] = useState(
              rowsClientes.map((c) => ({
                numeroCodigoPostal: getCodigoPostal(c.clientePersonaId) || 0,
                numeroCliente: c.numeroCliente,
              }))
            );
            const [cuits, setCuits] = useState(
              rowsClientes.map((c) => ({
                numeroCuitCliente: getCuitCliente(c.clientePersonaId) || 0,
                numeroCliente: c.numeroCliente,
              }))
            );
            const [campos, setCampos] = useState([...rowsClientes]);
            const [clientes, setClientes] = useState([]);
            //Funciones para el formulario
            function getNombreCliente(id) {
              let persona = (personas || []).find(
                (p) => p.personaId === id
              );
              let nombreCompleto = persona.nombre + " " + persona.apellido;
              if (nombreCompleto.length > 30) {
                let nombre = persona.nombre.split(" ");
                nombreCompleto = nombre[0] + " " + persona.apellido;
              }
              return nombreCompleto;
            }
            function getDireccion(id) {
              let persona = (personas || []).find(
                (p) => p.personaId === id
              );
              const min = 100;
              const max = 1500;

              const randomNumber =
                Math.floor(Math.random() * (max - min + 1)) + min;
              // return (persona.calle !== null ? persona.calle : '') + " " + (persona.altura !== null ? persona.altura : '')
              return (
                calles[Math.floor(Math.random() * (49 - 0 + 1)) + 0] +
                " " +
                randomNumber.toString()
              );
            }
            function getLocalidadCliente(id) {
              let persona = (personas || []).find(
                (p) => p.personaId === id
              );
              return persona.ciudad === null ? "" : persona.ciudad;
            }
            function getCodigoPostal(id) {
              let persona = (personas || []).find(
                (p) => p.personaId === id
              );
              return persona?.codigoPostal === null
                ? ""
                : persona?.codigoPostal;
            }
            const handleCampoChange = (value, propiedad, row) => {
              let newR = { ...row };
              if (propiedad === 2) {
                newR = { ...newR, tipoOperacion: value };
              }
              if (propiedad === 1) {
                newR = {
                  ...newR,
                  clientePersonaId: value,
                  numeroCodigoPostal: getCodigoPostal(value),
                  numeroCuitCliente: getCuitCliente(value),
                };
              }
              setCampos(
                campos.map((c) =>
                  c.numeroCliente === row.numeroCliente ? (c = newR) : c
                )
              );
            };
            const CodigoPostalCell = (v) => {
              const [cp, setCp] = useState(
                cps.find((c) => c.numeroCliente === v.row.numeroCliente)
                  .numeroCodigoPostal
              );
              const handleChange = (e) => {
                setCps([
                  ...cps.map((c) =>
                    c.numeroCliente === v.row.numeroCliente
                      ? { ...c, numeroCodigoPostal: e.target.value }
                      : c
                  ),
                ]);
                setCp(e.target.value);
              };
              return (
                <FormControl fullWidth>
                  <Input
                    value={cp}
                    onChange={handleChange}
                    id="outlined-adornment-weight"
                    type="number"
                  />
                </FormControl>
              );
            };
            const CuitCell = (v) => {
              const [cuit, setCuit] = useState(
                cuits.find((c) => c.numeroCliente === v.row.numeroCliente)
                  .numeroCuitCliente
              );
              const handleChange = (e) => {
                setCuits([
                  ...cuits.map((c) =>
                    c.numeroCliente === v.row.numeroCliente
                      ? { ...c, numeroCuitCliente: e.target.value }
                      : c
                  ),
                ]);
                setCuit(e.target.value);
              };
              return (
                <FormControl fullWidth>
                  <Input
                    value={cuit}
                    onChange={handleChange}
                    id="outlined-adornment-weight"
                    type="number"
                  />
                </FormControl>
              );
            };
            //Columnas del formulario
            const columns = [
              {
                field: "numeroCliente",
                headerName: "Contrato Id",
                width: 70,
                valueGetter: (v) => parseInt(v.row.numeroCliente),
              },
              {
                headerName: "Tipo de Contrato",
                width: 200,
                valueGetter: (v) =>
                  v.row.numeroCliente
                    ? getClaseContrato(parseInt(v.row.numeroCliente))
                    : "-",
              },
              {
                field: "clientePersonaId",
                headerName: "Cliente",
                width: 200,
                renderCell: (v) => {
                  let titulares = (
                    titularidades || []
                  ).filter(
                    (t) => t.contratoId === parseInt(v.row.numeroCliente)
                  );
                  return titulares.length > 1 ? (
                    <FormControl fullWidth>
                      <Select
                        sx={{
                          boxShadow: "none",
                          ".MuiOutlinedInput-notchedOutline": { border: 0 },
                          width: "100%",
                        }}
                        label="Cliente"
                        name="clientePersonaId"
                        value={parseInt(v.row.clientePersonaId)}
                        onChange={(e) =>
                          handleCampoChange(e.target.value, 1, v.row)
                        }
                      >
                        {getDropdownOptions(v.row.numeroCliente)}
                      </Select>
                    </FormControl>
                  ) : (
                    <Typography>
                      {getLabel(parseInt(v.row.clientePersonaId))}
                    </Typography>
                  );
                },
              },
              {
                field: "numeroCuitCliente",
                headerName: "CUIT",
                width: 200,
                renderCell: CuitCell,
              },
              {
                field: "numeroCodigoPostal",
                headerName: "Codigo Postal",
                width: 200,
                renderCell: CodigoPostalCell,
              },
              {
                field: "tipoOperacion",
                headerName: "Tipo de Operacion",
                width: 170,
                renderCell: (v) => {
                  return (
                    <FormControl fullWidth>
                      <Select
                        label="Tipo de Operacion:"
                        name="tipoOperacion"
                        value={v.row.tipoOperacion}
                        required
                        onChange={(e) =>
                          handleCampoChange(e.target.value, 2, v.row)
                        }
                      >
                        <MenuItem value="A">"A" → Actualizacion</MenuItem>
                        <MenuItem value="B">"B" → Baja</MenuItem>
                      </Select>
                    </FormControl>
                  );
                },
              },
            ];
            //Modal confirmación
            const [modalConfirmacion, setModalConfirmacion] = useState(false);
            const openModalConfirmacion = () => setModalConfirmacion(true);
            const closeModalConfirmacion = () => setModalConfirmacion(false);
            const ModalConfirmacion = (props) => {
              function handleCreate() {
                dispatch(addCamposCobranza(clientes))
                  .unwrap()
                  .then(console.log)
                  .catch(console.log);
              }
              return (
                <Fragment>
                  <Dialog
                    onClose={closeModalConfirmacion}
                    open={modalConfirmacion}
                    maxWidth="md"
                  >
                    <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Confirmar:</DialogTitle>
                    <DialogContent dividers>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography>
                            ¿Seguro quiere crear el nuevo registro de deuda?
                            Esta acción no podrá deshacerse.
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography>
                            Ha seleccionado {clientes.length}{" "}
                            {clientes.length > 1 ? "clientes" : "cliente"} para
                            la publicación.
                          </Typography>
                        </Grid>
                      </Grid>
                    </DialogContent>
                    <DialogActions>
                      <Button
                      disabled={fetching > 0}
                        variant="contained"
                        onClick={handleCreate}
                        sx={{ marginRight: "5px", marginButtom: "15px" }}
                      >
                        {"Aceptar"}
                      </Button>
                      <Button
                      disabled={fetching > 0}
                        variant="outlined"
                        onClick={closeModalConfirmacion}
                        sx={{ marginRight: "5px", marginButtom: "15px" }}
                      >
                        {"Cancelar"}
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Fragment>
              );
            };
            //Función que se llama al apretar el botón 'Aceptar' y raliza validaciones.
            function handleSubmit() {
              let camposFiltrados = [...campos].filter((c) =>
                selectedRows.includes(c.numeroCliente)
              );
              setErrores([]);
              for (let campo of camposFiltrados) {
                campo.numeroCodigoPostal = cps.find(
                  (c) => c.numeroCliente === campo.numeroCliente
                ).numeroCodigoPostal;
                campo.numeroCuitCliente = cuits.find(
                  (c) => c.numeroCliente === campo.numeroCliente
                ).numeroCuitCliente;
                let tipoCuit = campo?.numeroCuitCliente
                  ?.toString()
                  ?.slice(0, 2);
                let errs = [];
                let huboError = false;
                if (
                  campo.clientePersonaId === undefined ||
                  campo.clientePersonaId === ""
                ) {
                  errs = [
                    ...errs,
                    "Contrato N° " +
                    campo.numeroCliente +
                    ': Debe completar el campo "Cliente"',
                  ];
                }
                if (
                  campo.numeroCodigoPostal === undefined ||
                  campo.numeroCodigoPostal === ""
                ) {
                  errs = [
                    ...errs,
                    "Contrato N° " +
                    campo.numeroCliente +
                    ': Debe completar el campo "Cógido Postal"',
                  ];
                }
                if (
                  (campo.numeroCodigoPostal.toString().length !== 4) &
                  !(
                    campo.numeroCodigoPostal === undefined ||
                    campo.numeroCodigoPostal === ""
                  )
                ) {
                  errs = [
                    ...errs,
                    "Contrato N° " +
                    campo.numeroCliente +
                    ': Debe ingresar un Código postal de 4 digitos. El campo "Código postal" tiene ' +
                    campo.numeroCodigoPostal.toString().length +
                    " digitos.",
                  ];
                }
                if (
                  campo.numeroCuitCliente.toString().length !== 11 &&
                  !(
                    campo.numeroCuitCliente === undefined ||
                    campo.numeroCuitCliente === ""
                  )
                ) {
                  errs = [
                    ...errs,
                    "Contrato N° " +
                    campo.numeroCliente +
                    ': Debe ingresar un N° de CUIT de 11 digitos. El campo "CUIT" tiene ' +
                    campo.numeroCuitCliente.toString().length +
                    " digitos.",
                  ];
                }
                if (
                  ![
                    "30",
                    "33",
                    "34",
                    "20",
                    "23",
                    "24",
                    "25",
                    "26",
                    "27",
                  ].includes(tipoCuit)
                ) {
                  errs = [
                    ...errs,
                    "Contrato N° " +
                    campo.numeroCliente +
                    ": Debe ingresar un N° de CUIT que comience con 30, 33, 34, 20, 23, 24, 25, 26 o 27.",
                  ];
                }
                if (errs.length > 0) {
                  huboError = true;
                }
                setErrores(errs);
                if (huboError) return;
                campo.numeroCuota = "0".repeat(4);
                campo.nombreCliente = handleString(
                  getNombreCliente(campo.clientePersonaId)
                );
                campo.descripcionLocalidad = handleString(
                  getLocalidadCliente(campo.clientePersonaId)
                );
                campo.direccionCliente = handleString(
                  getDireccion(campo.clientePersonaId)
                );
              }
              setClientes([...camposFiltrados]);
              openModalConfirmacion();
            }
            return (
              <Fragment>
                <Dialog
                  onClose={closeClientesModal}
                  open={mostrarNuevoRegistro}
                  maxWidth="lg"
                >
                  <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Crear nuevo Registro:</DialogTitle>
                  <DialogContent dividers>
                    <Box fullWidth >
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          Seleccione los clientes para el nuevo registro:
                        </Grid>
                        <DataGridPro
                          fullWidth
                          pagination
                          sx={{ height: '60vh' }}
                          getRowId={(r) => r.numeroCliente}
                          initialState={{
                            sorting: {
                              sortModel: [{ field: "ID", sort: "desc" }],
                            },
                          }}
                          rows={campos}
                          columns={columns}
                          checkboxSelection
                          disableRowSelectionOnClick
                          rowSelectionModel={selectedRows}
                          onRowSelectionModelChange={(newRowSelectionModel) => {
                            setSelectedRows(newRowSelectionModel);
                          }}
                          experimentalFeatures={{ newEditingApi: true }}
                          components={{
                            Toolbar: () => {
                              return <Fragment>
                                <GridToolbarContainer>
                                  <Grid conteiner
                                    rowSpacing={0} sx={{
                                      display: "inline-flex",
                                      justifyContent: "space-between",
                                      alignItems: "strech",
                                      width: "100%"
                                    }}>
                                    <Grid fullWidth>
                                      <GridToolbarColumnsButton /><GridToolbarFilterButton /> <GridToolbarDensitySelector />
                                      {currentUser?.permisos?.includes('export-data') ? <GridToolbarExport />
                                        : ''}
                                    </Grid>
                                    <GridToolbarQuickFilter />
                                  </Grid>
                                </GridToolbarContainer>
                              </Fragment>
                            }
                          }}
                          componentsProps={{
                            toolbar: {
                              showQuickFilter: true,
                              quickFilterProps: { debounceMs: 500 },
                              export: false,
                            },
                          }}
                          gridLinesVisibility="None"
                          slotProps={{
                            toolbar: {
                              showQuickFilter: true,
                            },
                          }}
                        />
                        <Grid item xs={12} sx={{ color: "error.main" }}>
                          {errores.length > 0 &&
                            errores.map((error, i) => (
                              <p
                                style={{ marginLeft: "8px" }}
                                key={"errNuevoRegistro" + i}
                              >
                                - {error}
                              </p>
                            ))}
                        </Grid>
                      </Grid>
                    </Box>
                  </DialogContent>
                  <DialogActions>
                    <Button
                    disabled={fetching > 0}
                      variant="outlined"
                      onClick={closeClientesModal}
                    >
                      {"Cancelar"}
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleSubmit}
                      sx={{ marginRight: "5px", marginButtom: "15px" }}
                      disabled={selectedRows.length === 0 || fetching > 0 }
                    >
                      {"Aceptar"}
                    </Button>
                  </DialogActions>
                </Dialog>
                <ModalConfirmacion></ModalConfirmacion>
              </Fragment>
            );
          };
          return (
            <Fragment>
              <Button
              disabled={fetching > 0}
                size="small"
                variant="contained"
                sx={{ height: '4vh', width: '15%', fontWeight: 'bold', margin: '0.4em' }}
                onClick={() => setMostrarNuevoRegistro(true)}
              > Nuevo <AddIcon></AddIcon>
              </Button>
              <NuevoRegistro></NuevoRegistro>
            </Fragment>
          );
        };
        return (
          <Fragment>
            <DetalleModal></DetalleModal>
            <Box
              fullWidth
            >
              <DataGridPro
                pagination
                fullWidth
                sx={{ height: '70vh' }}
                getRowId={(r) => r.registroId}
                rows={rows || []}
                columns={columns}
                disableSelectionOnClick
                experimentalFeatures={{ newEditingApi: true }}
                components={{
                  Toolbar: () => {
                    return <Fragment>
                      <GridToolbarContainer>
                        <Grid conteiner
                          rowSpacing={0} sx={{
                            display: "inline-flex",
                            justifyContent: "space-between",
                            alignItems: "strech",
                            width: "100%",
                          }}>
                          {currentUser?.permisos?.includes("writeCobranzas") ? <BtnBar /> : null}
                          <Grid sx={{ width: "100%", marginLeft: '1em' }}>
                            <GridToolbarColumnsButton /><GridToolbarFilterButton /> <GridToolbarDensitySelector />
                            {currentUser?.permisos?.includes('export-data') ? <> <GridToolbarExport /> </>
                              : ''}
                          </Grid>
                          <GridToolbarQuickFilter />
                        </Grid>
                      </GridToolbarContainer>
                    </Fragment>
                  }
                }}
                componentsProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
                loading={fetching > 0}
              />
            </Box>
          </Fragment>
        );
      } //-------------FIN REGISTROS
      //-------------------------------------Rendiciones
      function Rendiciones() {
        let rows = [...(rendiciones || [])]
          .sort((a, b) => b.rendicionId - a.rendicionId)
          .map((r) => ({
            ...r,
            cantidadClientes: (
              detallesRendicion || []
            )?.filter((d) => d.rendicionId === r.rendicionId).length,
            totalImporteRendido: parseInt(r.totalImporteRendido) / 100,
          }));
        const [detalleModal, setDetalleModal] = useState(false);
        const [showDetalleModal, setShowDetalleModal] = useState(false);
        const openDetalleModal = () => setShowDetalleModal(true);
        const closeDetalleModal = () => setShowDetalleModal(false);
        //Funciónes de Botones DataGrid
        function handleDetalle(id) {
          setDetalleModal(id);
          openDetalleModal();
        }
        function getMarcaAcreditacion(acreditacion, des) {
          let estado = acreditacion;
          switch (acreditacion) {
            case ' ':
            case 'A':
            case 'E':
              estado = 'Acreditado';
              break;
            case 'S':
              estado = 'Acreditado';
              break;
            case 'R':
              estado = 'Rechazado';
              break;
            case 'D':
              estado = 'Diferido';
              break;
            case 'P':
              if (des.startsWith('EFERAPI')) {
                estado = 'Acredita a las 48HS.';
              }
              if (des.startsWith('INTERPGO')) {
                estado = 'Pendiente (no vino información de interbanking)';
              }
              break;
            case 'T':
              estado = 'Rescatado';
              break;
            case 'C':
              estado = 'Cesionado desde la custodia';
              break;
            case 'Y':
              estado = 'Fallas técnicas o cheque posdatado';
              break;
            case 'V':
              estado = 'Faltante';
              break;
            case 'X':
              estado = 'Rechazo con posible redepósito';
              break;
            case 'U':
              estado = 'Rechazo con redepósito';
              break;
            case 'Z':
              estado = 'Cheque no redepositado';
              break;
            case 'B':
              estado = 'A conformar';
              break;
            default:
              // Manejar el caso por defecto si no se cumple ninguna condición
              break;
          }
          return estado
        }
        const DetalleModal = (props) => {
          let detalles = (detallesRendicion || [])
            .filter((d) => d.rendicionId === detalleModal)
            .map((d) => {
              return ({
                ...d,
                tipoContrato: getClaseContrato(parseInt(d.numeroCliente)),
                totalPago: d.totalPago / 100,
                fechaPago: getFormatoFecha(d.fechaPago),
              })
            });
          let instrumentosDetalles = (instrumentosRendicion || [])?.filter(i => detalles?.map(d => d.detalleRendicionId)?.includes(i.detalleRendicionId))?.map(i => ({
            ...i,
            tipoContrato: getClaseContrato(parseInt(i.numeroCliente)),
            fechaPago: getFormatoFecha(i.fechaAcreditacion),
            importe: (parseFloat(i.importe) / 100),
            marcaAcreditacion: getMarcaAcreditacion(i.marcaAcreditacion, i.descripcionFormaPago)
          }));
          let rows = instrumentosDetalles || [];
          const columns = [
            {
              field: "numeroCliente",
              headerName: "Contrato ID",
              width: 100,
              valueGetter: (v) => parseInt(v.row.numeroCliente),
            },
            { field: "tipoContrato", headerName: "Tipo Contrato", width: 170 },
            {
              field: "nombreCliente",
              headerName: "Nombre del cliente",
              width: 200, renderCell: (v) =>
                getLabel(getTitularidad(parseInt(v.row.numeroCliente))),
            },
            { field: "fechaPago", headerName: "Fecha de pago", width: 100 },
            { field: "marcaAcreditacion", headerName: "Estado del pago", width: 200 },
            {
              field: "importe",
              headerName: "Importe",
              width: 100,
              renderCell: (v) =>
                ('$' + moneyFormat(parseFloat(v.row.importe))),
              sortComparator: importeSortComparator,
            },
          ];
          return (
            <Fragment>
              <Dialog
                onClose={closeDetalleModal}
                open={showDetalleModal}
                maxWidth="lg"
              >
                <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>
                  Detalles de la rendición:
                </DialogTitle>
                <DialogContent dividers>
                  <Box
                    sx={{ paddingTop: "5px", width: 1000 }}
                    style={{ paddingTop: "5px" }}
                  >
                    <DataGridPro
                      pagination
                      sx={{ height: '65vh', width: '100%' }}
                      getRowId={(r) => r.detalleRendicionId}
                      initialState={{
                        sorting: {
                          sortModel: [{ field: "ID", sort: "asc" }],
                        },
                      }}
                      rows={rows || []}
                      columns={columns}
                      //checkboxSelection
                      //disableSelectionOnClick
                      experimentalFeatures={{ newEditingApi: true }}
                      //onSelectionModelChange={false}
                      components={{ Toolbar: GridToolbar }}
                      componentsProps={{
                        toolbar: {
                          showQuickFilter: true,
                          quickFilterProps: { debounceMs: 500 },
                        },
                      }}
                      slotProps={{
                        toolbar: {
                          showQuickFilter: true,
                        },
                      }}
                    />
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Button disabled={fetching > 0} onClick={() => setShowDetalleModal(false)}>
                    Volver
                  </Button>
                </DialogActions>
              </Dialog>
            </Fragment>
          );
        };
        const BtnBar = (props) => {
          function handleChange(e) {
            let rFile = e.target.files[0];
            let fileReader = new FileReader();
            fileReader.readAsText(rFile);
            fileReader.onload = (e) => {
              let arrayFile = fileReader.result.split('\n');
              arrayFile.push(rFile.name);
              dispatch(addRendicionCobranza(arrayFile)).unwrap().then(console.log).catch(console.log);
            };
            fileReader.onerror = (e) => {
              console.log(fileReader.result);
            };
          }

          return (
            <Fragment>
              <div
                style={{
                  position: 'relative',
                  minWidth: '100%',
                  height: '35px',
                }}>
                <Button
                disabled={fetching > 0}
                  size="small"
                  sx={{ minWidth: 250 }}
                  style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '15%',
                    zIndex: '0',
                    fontWeight: "bold",
                    color: "white"
                  }}
                  variant="contained">
                  Cargar Archivo de Rendicion<FileUploadIcon></FileUploadIcon>
                </Button>
                <input
                  style={{
                    opacity: '0',
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '250px',
                    height: '100%',
                    zIndex: '2',
                  }}
                  type="file"
                  onChange={handleChange}
                  className="input-field"
                  id="file"
                  value={''}
                />
              </div>
            </Fragment>
          );
        };
        const columns = [
          {
            field: "numeroRendicion",
            headerName: "Rendición ID",
            width: 100,
            valueGetter: (v) => parseInt(v.row.numeroRendicion),
          },
          {
            field: "fechaRendicion",
            headerName: "Fecha de la Rendición",
            width: 150,
            valueGetter: (v) => getFormatoFecha(v.row.fechaRendicion),
            sortComparator: fechaSortComparator,
          },
          {
            field: "fechaEdicion",
            headerName: "Carga en el sistema",
            width: 150,
            valueGetter: (v) => getFormatoFecha(getFecha(v.row.fechaEdicion)),
            sortComparator: fechaSortComparator,
          },
          {
            field: "cantidadClientes",
            headerName: "Clientes informados",
            width: 150,
          },
          {
            field: "cantidadPagos",
            headerName: "Cantidad de pagos",
            width: 150,
            valueGetter: (v) => parseInt(v.row.cantidadPagosRendidos),
          },
          {
            field: "totalImporteRendido",
            headerName: "Total recaudado",
            width: 250,
            valueGetter: (v) => ('$' + moneyFormat(parseFloat(v.row.totalImporteRendido))),
            sortComparator: importeSortComparator,
          },
          //{ field: 'totalImporteRendido', headerName: 'Total recaudado', width: 10, valueGetter: (v) => '$' + new Intl.NumberFormat('es-ES').format(v.row.totalImporteRendido / 100), sortComparator: importeSortComparator},
          {
            field: 'actions', headerName: 'Acciones', width: 100, type: 'actions', renderCell: v =>
              <>
                <GridActionsCellItem key={v.row.rendicionId + '-verDetallesRendicionesGridAction'} disabled={currentUser?.permisos?.includes("readCobranzas") ? false : true} color={'primary'} onClick={() => handleDetalle(v.row.rendicionId)} icon={<GridAction label={'Ver Detalles'} key={'cobranza-rendiciones-' + v.row.rendicionId} Icon={VisibilityIcon} />} />
              </>
          }
        ];
        return (
          <Fragment>
            <Box fullWidth>
              {/* <BtnBar/> */}
              <DataGridPro
                pagination
                sx={{ height: '70vh', width: '100%' }}
                getRowId={(r) => r.rendicionId}
                rows={rows || []}
                columns={columns}
                experimentalFeatures={{ newEditingApi: true }}
                components={{ Toolbar: GridToolbar }}
                componentsProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
                loading={fetching > 0}
              />
            </Box>
            <DetalleModal></DetalleModal>
          </Fragment>
        );
      } //------------FIN RENDICIONES
      //-------------------------------------Tab Panel
      function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
          <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
          >
            {value === index && (
              <Box sx={{ p: 3 }}>
                <Typography>{children}</Typography>
              </Box>
            )}
          </div>
        );
      }
      const ModalTabs = () => {
        function a11yProps(index) {
          return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
          };
        }
        const handleChange = (event, newValue) => {
          setValue(newValue);
        };

        return (
          <>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="Publicaciones" {...a11yProps(0)} />
                <Tab label="CVUS" {...a11yProps(1)} />
                <Tab label="Rendiciones" {...a11yProps(2)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <RegistrosCobranza />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <CVUS />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <Rendiciones />
            </TabPanel>
          </>
        );
      };
      return <ModalTabs />;
    };
    // Getnet ------------
    const GetNetTable = (props) => {
      return 'GetNet';
    };
    return (
      <Fragment>
        {type === 'cuenta-recaudadora' ? (
          <RegistrosyRendicionesTable></RegistrosyRendicionesTable>
        ) : type === 'debito' ? (
          <DebitoDirectoTable></DebitoDirectoTable>
        ) : (
          <GetNetTable></GetNetTable>
        )}
      </Fragment>
    );
  };
  return (
    <Fragment>
      {fetching > 0 && <p>Cargando</p>}
      <Cobranzas></Cobranzas>
    </Fragment>
  );
}
